export default {
  // Navigation
  'nav.trips': 'Voyages',
  'nav.findTrips': 'Trouver des voyages',
  'nav.chat': 'Chat',
  'nav.welcomeBack': 'Bon retour!',
  'nav.logout': 'Déconnexion',
  'nav.settings': 'Paramètres',
  'nav.wallet': 'Portefeuille',
  'nav.profile': 'Profil',
  'nav.notifications': 'Notifications',
  'nav.noNotifications': 'Aucune notification',
  'nav.markAllRead': 'Tout marquer comme lu',
  
  // Flexy Courie
  'nav.flexyCourie': 'Flexy Courier',
  'nav.flexyRide': 'Flexy Ride',
  'nav.asSender': 'En tant qu\'expéditeur',
  'nav.asTraveler': 'En tant que voyageur',
  'nav.driver': 'Conducteur',
  'nav.passenger': 'Passager',
  'nav.mySeatListings': 'Mes annonces de sièges',
  'nav.viewManageSeatListings': 'Voir et gérer vos annonces de sièges',
  'nav.myRequests': 'Mes demandes',
  'nav.viewSeatRequests': 'Voir vos demandes de sièges',
  'nav.createSeatListing': 'Créer une annonce de siège',
  'nav.listNewSeat': 'Lister un nouveau siège',
  'nav.myPassengerListings': 'Mes annonces de passagers',
  'nav.viewManagePassengerListings': 'Voir et gérer vos annonces de passagers',
  'nav.myApplications': 'Mes candidatures',
  'nav.viewPassengerApplications': 'Voir vos candidatures de passagers',
  'nav.createPassengerListing': 'Créer une annonce de passager',
  'nav.createNewPassengerListing': 'Créer une nouvelle annonce de passager',
  'nav.imSender': 'Je suis un expéditeur',
  'nav.searchTravelersSendPackages': 'Rechercher des voyageurs et envoyer des colis',
  'nav.imTraveler': 'Je suis un voyageur',
  'nav.listTripsEarnMoney': 'Lister des voyages et gagner de l\'argent',
  'nav.imPassenger': 'Je suis un passager',
  'nav.seeDriverSeatListings': 'Voir les annonces de sièges de conducteurs',
  'nav.imDriver': 'Je suis un conducteur',
  'nav.seePassengerRideRequests': 'Voir les demandes de trajet de passagers',
  
  // Wallet
  'wallet.addMoney': 'Ajouter de l\'argent',
  'wallet.withdrawMoney': 'Retirer de l\'argent',
  'wallet.balance': 'Solde',
  'wallet.transactions': 'Transactions',
  'wallet.depositFunds': 'Déposer des fonds',
  'wallet.addBalance': 'Ajouter un solde',
  'wallet.fundWalletDescription': 'Alimentez votre portefeuille FlexySwap pour envoyer des demandes de colis instantanément. Les dépôts sont traités en toute sécurité via Stripe et suivis dans l\'historique de votre portefeuille.',
  'wallet.currentBalance': 'Solde actuel',
  'wallet.chooseAmount': 'Choisir le montant',
  'wallet.customAmount': 'Montant personnalisé',
  'wallet.minimumDeposit': 'Le dépôt minimum est de 10,00 CAD. Les dépôts sont définitifs une fois confirmés.',
  'wallet.cardHolderName': 'Nom du titulaire de la carte',
  'wallet.email': 'Email',
  'wallet.savedCards': 'Cartes enregistrées',
  'wallet.loadingCards': 'Chargement des cartes...',
  'wallet.noSavedCards': 'Aucune carte enregistrée pour le moment. Ajoutez une carte lors du paiement pour l\'enregistrer.',
  'wallet.addNewCard': '+ Ajouter une nouvelle carte',
  'wallet.cardDetails': 'Détails de la carte',
  'wallet.cardDetailsReady': 'Détails de la carte prêts',
  'wallet.enterCardInfo': 'Entrer les informations de la carte',
  'wallet.readyToCharge': 'Prêt à facturer cette carte.',
  'wallet.openSecurePanel': 'Ouvrez le panneau sécurisé pour saisir le numéro de carte, l\'expiration et le CVC.',
  'wallet.editCard': 'Modifier la carte',
  'wallet.enterCard': 'Entrer la carte',
  'wallet.addAmount': 'Ajouter {{amount}}',
  'wallet.processing': 'Traitement...',
  'wallet.poweredByStripe': 'Alimenté en toute sécurité par Stripe. Les détails de votre carte ne touchent jamais les serveurs de FlexySwap.',
  'wallet.secure': 'Sécurisé',
  'wallet.enterCardDetails': 'Entrer les détails de la carte',
  'wallet.close': 'Fermer',
  'wallet.cardDataEncrypted': 'Les données de la carte sont cryptées et traitées par Stripe. FlexySwap ne voit jamais ni ne stocke votre numéro de carte.',
  'wallet.cardNumber': 'Numéro de carte',
  'wallet.expiry': 'Expiration',
  'wallet.cvc': 'CVC',
  'wallet.saveCardForFuturePayments': 'Enregistrer la carte pour les paiements futurs',
  'wallet.cardDetailsEncrypted': 'Les détails de votre carte sont cryptés et stockés en toute sécurité par Stripe. Vous pouvez supprimer les cartes enregistrées à tout moment.',
  'wallet.done': 'Terminé',
  'wallet.cardInformation': 'Informations de la carte',
  'wallet.nameOnCard': 'Nom sur la carte',
  'wallet.mmYy': 'MM/AA',
  'wallet.billingAddress': 'Adresse de facturation',
  'wallet.countryOrRegion': 'Pays ou région',
  'wallet.postalCode': 'Code postal',
  'wallet.savePaymentDetails': 'Enregistrer les détails de paiement sur FlexySwap pour les achats futurs',
  'wallet.withdrawFunds': 'Retirer des fonds',
  'wallet.cashOutEarnings': 'Encaisser les gains',
  'wallet.transferBalanceDescription': 'Transférez le solde de votre FlexySwap vers votre compte Stripe connecté. Assurez-vous que vos détails de paiement sont vérifiés pour éviter les retards de traitement.',
  'wallet.availableBalance': 'Solde disponible',
  'wallet.setupWithdrawalAccount': 'Configurer le compte de retrait',
  'wallet.connectStripeDescription': 'Connectez votre compte Stripe pour activer les retraits. Vous devrez compléter le processus d\'intégration de Stripe pour vérifier votre identité et vos informations bancaires.',
  'wallet.setupAccount': 'Configurer le compte',
  'wallet.settingUp': 'Configuration...',
  'wallet.checkStatus': 'Vérifier le statut',
  'wallet.checking': 'Vérification...',
  'wallet.accountReadyForWithdrawals': 'Compte prêt pour les retraits',
  'wallet.accountSetupInProgress': 'Configuration du compte en cours. Veuillez compléter la configuration si nécessaire.',
  'wallet.completeAccountSetup': 'Compléter la configuration du compte',
  'wallet.refreshAccountStatus': 'Actualiser le statut du compte',
  'wallet.withdrawalAccount': 'Compte de retrait',
  'wallet.accountId': 'ID du compte:',
  'wallet.payouts': 'Paiements:',
  'wallet.enabled': 'Activé',
  'wallet.disabled': 'Désactivé',
  'wallet.pending': 'En attente',
  'wallet.changeWithdrawalAccount': 'Changer le compte de retrait',
  'wallet.withdrawalAmount': 'Montant du retrait',
  'wallet.quickAmounts': 'Montants rapides',
  'wallet.withdraw': 'Retirer {{amount}}',
  'wallet.withdrawButton': 'Retirer',
  'wallet.submitting': 'Soumission...',
  'wallet.withdrawalsProcessed': 'Les retraits sont traités via Stripe Connect. Assurez-vous que votre compte de paiement est entièrement vérifié. Les délais de traitement peuvent varier selon votre banque.',
  'wallet.stripeTestInstructions': 'Instructions de test Stripe',
  'wallet.connectUpdateInstructions': 'Cliquez sur "Connecter / mettre à jour" pour ouvrir l\'intégration de Stripe. Utilisez les données de test des docs Stripe (par exemple, pays États-Unis, type d\'entreprise Individuel).',
  'wallet.bankingInfoInstructions': 'Lorsque vous êtes invité à saisir les informations bancaires, entrez le numéro de routage 110000000 et le numéro de compte 000123456789.',
  'wallet.afterSubmittingInstructions': 'Après avoir soumis, cliquez sur "Vérifier le statut" pour actualiser l\'état de la connexion, puis demandez un retrait.',
  'wallet.checkingAccountStatus': 'Vérification du statut du compte...',
  'wallet.payoutAccount': 'Compte de paiement',
  'wallet.notConnected': 'Non connecté',
  'wallet.connected': 'Connecté',
  'wallet.connectUpdate': 'Connecter / mettre à jour',
  'wallet.amount': 'Montant',
  'wallet.withdrawalsLimited': 'Les retraits sont limités à votre solde disponible.',
  'wallet.stripeConnectReturn.accountCreatedSuccessfully': 'Votre compte a été créé avec succès!',
  'wallet.stripeConnectReturn.accountReady': 'Votre compte Stripe Connect est prêt. Vous pouvez maintenant effectuer des transactions de retrait.',
  'wallet.stripeConnectReturn.returnToMobileApp': 'Vous pouvez retourner à l\'application mobile',
  'wallet.stripeConnectReturn.appWillOpen': 'L\'application s\'ouvrira automatiquement. Si elle ne s\'ouvre pas, cliquez sur le bouton ci-dessous.',
  'wallet.stripeConnectReturn.openApp': 'Ouvrir l\'application',
  'wallet.stripeConnectReturn.redirectingToWallet': 'Redirection vers votre portefeuille...',
  'wallet.stripeConnectRefresh.additionalInfoRequired': 'Informations supplémentaires requises',
  'wallet.stripeConnectRefresh.completeSetup': 'Nous avons besoin d\'informations supplémentaires pour compléter votre compte. Veuillez compléter la configuration.',
  'wallet.stripeConnectRefresh.redirectingToSetup': 'Redirection vers la configuration du compte...',
  
  // Common
  'common.back': 'Retour',
  'common.close': 'Fermer',
  'common.save': 'Enregistrer',
  'common.cancel': 'Annuler',
  'common.delete': 'Supprimer',
  'common.edit': 'Modifier',
  'common.submit': 'Soumettre',
  'common.loading': 'Chargement...',
  'common.error': 'Erreur',
  'common.success': 'Succès',
  'common.confirm': 'Confirmer',
  'common.yes': 'Oui',
  'common.no': 'Non',
  'common.search': 'Rechercher',
  'common.filter': 'Filtrer',
  'common.sort': 'Trier',
  'common.clear': 'Effacer',
  'common.apply': 'Appliquer',
  'common.reset': 'Réinitialiser',
  'common.next': 'Suivant',
  'common.previous': 'Précédent',
  'common.done': 'Terminé',
  'common.select': 'Sélectionner',
  'common.all': 'Tout',
  'common.none': 'Aucun',
  'common.required': 'Requis',
  'common.optional': 'Optionnel',
  'common.at': 'à',
  'common.unknownUser': 'Utilisateur inconnu',
  'common.notAvailable': 'N/D',
  'common.pending': 'En attente',
  'common.accepted': 'Accepté',
  'common.rejected': 'Refusé',
  'common.completed': 'Terminé',
  'common.delivered': 'Livré',
  'common.cancelled': 'Annulé',
  'common.unknown': 'Inconnu',
  
  // Language
  'language.english': 'English',
  'language.french': 'Français',
  'language.selectLanguage': 'Sélectionner la langue',
  
  // Auth
  'auth.pleaseSignIn': 'Veuillez vous connecter pour gérer le solde de votre portefeuille.',
  'auth.goToLogin': 'Aller à la connexion',
  'auth.signIn': 'Se connecter',
  'auth.signUp': 'S\'inscrire',
  'auth.createAccount': 'Créer un compte',
  
  // Wallet additional
  'wallet.toWallet': 'au portefeuille',
  'wallet.pleaseSignIn': 'Veuillez vous connecter pour gérer le solde de votre portefeuille.',
  'wallet.depositSuccessful': 'Dépôt réussi. Le solde de votre portefeuille sera mis à jour sous peu.',
  'wallet.paymentFailed': 'Le paiement a échoué. Veuillez réessayer.',
  'wallet.stripeClientSecretMissing': 'Secret client Stripe manquant.',
  'wallet.paymentReferenceMissing': 'Référence de paiement manquante.',
  'wallet.failedToCreateCustomer': 'Échec de la création du client',
  'wallet.selectedCardNotAssociated': 'La carte sélectionnée n\'est pas associée à votre compte. Veuillez sélectionner une autre carte ou en ajouter une nouvelle.',
  'wallet.secureCardEntryNotReady': 'La saisie sécurisée de la carte n\'est pas encore prête. Veuillez attendre un moment et réessayer.',
  'wallet.pleaseEnterAtLeast': 'Veuillez entrer au moins 10,00 CAD pour continuer.',
  'wallet.maximumDepositAmount': 'Le montant maximum de dépôt est de 10 000,00 CAD.',
  'wallet.mustBeLoggedIn': 'Vous devez être connecté pour déposer des fonds.',
  'wallet.stripePaymentsNotAvailable': 'Les paiements Stripe ne sont pas disponibles dans {{country}}. Veuillez mettre à jour votre profil avec un pays pris en charge.',
  'wallet.cardDeletedSuccessfully': 'Carte supprimée avec succès',
  'wallet.failedToDeleteCard': 'Échec de la suppression de la carte',
  'wallet.customerIdNotFound': 'ID client introuvable',
  'wallet.deleteCardConfirm': 'Êtes-vous sûr de vouloir supprimer la carte se terminant par {{last4}} ?',
  'wallet.unableToLoadStripe': 'Impossible de charger Stripe en toute sécurité. Veuillez actualiser la page ou réessayer plus tard.',
  'wallet.addCard': 'Ajouter une carte',
  'wallet.email': 'E-mail',
  
  // Home Page
  'home.packageSwap': 'Échange de colis',
  'home.sendPackagesAnywhere': 'Envoyez des colis partout avec FlexySwap.',
  'home.flexyRide': 'Flexy Ride',
  'home.findRidesAnywhere': 'Trouvez des trajets partout',
  'home.imSender': 'Je suis un expéditeur',
  'home.imTraveler': 'Je suis un voyageur',
  'home.imDriver': 'Je suis un conducteur',
  'home.imPassenger': 'Je suis un passager',
  'home.whatIsFlexySwap': 'Qu\'est-ce que FlexySwap?',
  'home.flexySwapDescription': 'FlexySwap est une place de marché communautaire de confiance qui connecte les voyageurs ayant de l\'espace de bagages supplémentaire avec les personnes qui ont besoin d\'envoyer de petits articles à travers le monde, et les conducteurs avec les passagers cherchant à partager des trajets. Ensemble, nous transformons l\'allocation de bagages inutilisée et les sièges de voiture vides en un réseau de livraison et de transport pratique, abordable et social.',
  'home.ourMission': 'Notre Mission',
  'home.missionDescription': 'Construire un réseau logistique et de transport mondial peer-to-peer qui permet aux voyageurs de monétiser leur voyage et donne aux expéditeurs un moyen plus rapide, plus personnel et plus rentable de déplacer des articles à l\'échelle internationale, tout en connectant les conducteurs et les passagers pour des trajets partagés.',
  'home.ourVision': 'Notre Vision',
  'home.visionDescription': 'Devenir la plateforme logistique et de covoiturage peer-to-peer leader mondiale, rendant la livraison et le transport mondiaux aussi simples et sociaux que de prendre un trajet avec un ami.',
  'home.whyFlexySwap': 'Pourquoi FlexySwap',
  'home.theProblemWeSolve': 'Le problème que nous résolvons',
  'home.forTravelers': 'Pour les voyageurs',
  'home.travelersProblem': 'Jusqu\'à 70% des voyageurs ont une allocation de poids de bagages inutilisée, qui devient un actif gaspillé. Beaucoup reviennent également avec des devises étrangères restantes qui restent inactives.',
  'home.forSenders': 'Pour les expéditeurs',
  'home.sendersProblem': 'L\'expédition internationale pour les petits colis est lente, coûteuse et impersonnelle. Les transporteurs traditionnels facturent souvent des tarifs premium même pour les livraisons les plus simples.',
  'home.forDrivers': 'Pour les conducteurs',
  'home.driversProblem': 'Beaucoup de conducteurs voyagent avec des sièges vides dans leurs véhicules, manquant des opportunités de compenser les coûts de carburant et de rendre leurs trajets plus économiques. Les trajets longue distance peuvent être coûteux et solitaires.',
  'home.forPassengers': 'Pour les passagers',
  'home.passengersProblem': 'Trouver un transport abordable et pratique pour les trajets longue distance peut être difficile. Les options traditionnelles comme les bus ou les trains sont souvent coûteuses, inflexibles ou ne vont pas à votre destination exacte.',
  'home.theFlexySwapSolution': 'La solution FlexySwap',
  'home.solutionDescription': 'FlexySwap est construit sur une idée simple et puissante: pourquoi voler avec un espace de valise vide quand quelqu\'un à proximité a besoin d\'envoyer quelque chose à votre destination?',
  'home.solutionDescriptionRide': 'FlexySwap est construit sur une idée simple et puissante: pourquoi conduire avec des sièges vides quand quelqu\'un à proximité a besoin d\'un trajet vers votre destination?',
  'home.howItWorks': 'Comment ça marche',
  'home.simpleSteps': 'Étapes simples pour rendre chaque échange transparent',
  'home.stepsDescription': 'Les voyageurs et les expéditeurs suivent le même flux sécurisé pour garder les livraisons claires.',
  'home.stepsDescriptionRide': 'Les conducteurs et les passagers suivent le même flux sécurisé pour garder les trajets fluides.',
  'home.listATrip': 'Lister un voyage',
  'home.listATripDescription': 'Un voyageur publie son itinéraire, sa date et son espace de bagages sur FlexySwap.',
  'home.listARide': 'Lister un trajet',
  'home.listARideDescription': 'Un conducteur publie son itinéraire, sa date et ses sièges disponibles sur FlexySwap.',
  'home.findAMatch': 'Trouver une correspondance',
  'home.findAMatchDescription': 'Un expéditeur recherche un voyageur se dirigeant vers la bonne destination.',
  'home.findAMatchRide': 'Trouver une correspondance',
  'home.findAMatchRideDescription': 'Un passager recherche un conducteur se dirigeant vers la bonne destination.',
  'home.connectAgree': 'Connecter et convenir',
  'home.connectAgreeDescription': 'Les deux parties discutent en toute sécurité dans l\'application pour confirmer les détails du colis.',
  'home.connectAgreeRide': 'Connecter et convenir',
  'home.connectAgreeRideDescription': 'Les deux parties discutent en toute sécurité dans l\'application pour confirmer les détails du trajet.',
  'home.secureTheDeal': 'Sécuriser l\'affaire',
  'home.secureTheDealDescription': 'L\'expéditeur paie via l\'escrow de FlexySwap pour une livraison protégée.',
  'home.secureTheDealRide': 'Sécuriser l\'affaire',
  'home.secureTheDealRideDescription': 'Le passager paie via l\'escrow de FlexySwap pour un trajet protégé.',
  'home.deliverEarn': 'Livrer et gagner',
  'home.deliverEarnDescription': 'Le voyageur remet l\'article, confirme la livraison et est payé.',
  'home.completeEarn': 'Compléter et gagner',
  'home.completeEarnDescription': 'Le conducteur complète le trajet, le passager confirme l\'arrivée et le conducteur est payé.',
  'home.ourCoreFeatures': 'Nos fonctionnalités principales',
  'home.everythingYouNeed': 'Tout ce dont vous avez besoin pour des livraisons sécurisées et sociales',
  'home.everythingYouNeedRide': 'Tout ce dont vous avez besoin pour des trajets sécurisés et sociaux',
  'home.featuresDescription': 'Les outils intégrés maintiennent les voyageurs et les expéditeurs confiants à chaque étape de l\'échange.',
  'home.featuresDescriptionRide': 'Les outils intégrés maintiennent les conducteurs et les passagers confiants à chaque étape du trajet.',
  'home.peerToPeerNetwork': 'Réseau peer-to-peer',
  'home.peerToPeerDescription': 'Une alternative d\'expédition communautaire mondiale qui connecte de vraies personnes.',
  'home.peerToPeerDescriptionRide': 'Un réseau de covoiturage communautaire mondial qui connecte de vraies personnes.',
  'home.secureMessaging': 'Messagerie sécurisée',
  'home.secureMessagingDescription': 'Discutez en toute sécurité sans partager vos coordonnées privées.',
  'home.escrowPayment': 'Paiement en dépôt',
  'home.escrowPaymentDescription': 'Les transactions protégées gardent les fonds en sécurité jusqu\'à ce que la livraison soit confirmée.',
  'home.escrowPaymentDescriptionRide': 'Les transactions protégées gardent les fonds en sécurité jusqu\'à ce que le trajet soit complété.',
  'home.reviewSystem': 'Système d\'avis',
  'home.reviewSystemDescription': 'Faites confiance au réseau avec des évaluations communautaires après chaque échange.',
  'home.reviewSystemDescriptionRide': 'Faites confiance au réseau avec des évaluations communautaires après chaque trajet.',
  'home.currencySwap': 'Échange de devises',
  'home.currencySwapDescription': 'Échangez facilement les devises étrangères restantes avec les locaux sur l\'itinéraire.',
  'home.globalReach': 'Portée mondiale',
  'home.globalReachDescription': 'Connectez-vous avec des voyageurs et des expéditeurs du monde entier pour des itinéraires internationaux.',
  'home.globalReachDescriptionRide': 'Connectez-vous avec des conducteurs et des passagers du monde entier pour des itinéraires internationaux.',
  'home.swapEarn': 'Échanger et gagner',
  'home.welcomeBack': 'Bon retour',
  'home.driveWhenever': 'Conduisez quand vous voulez, gagnez ce dont vous avez besoin.',
  'home.listNextTrip': 'Listez votre prochain voyage et gardez les gains qui affluent.',
  'home.pickupPackages': 'Récupérez les colis près de chez vous et déposez-les le long de votre itinéraire. FlexySwap vous connecte avec des expéditeurs de confiance pour que chaque remise soit simple et sûre.',
  'home.publishTrip': 'Publiez un nouveau voyage, vérifiez les demandes entrantes et restez synchronisé avec la console que vous connaissez déjà depuis l\'application.',
  'home.getStarted': 'Commencer',
  'home.listNewTrip': 'Lister un nouveau voyage',
  'home.alreadyHaveAccount': 'Vous avez déjà un compte? Se connecter',
  'home.openSenderConsole': 'Ouvrir la console expéditeur',
  'home.handOffMoment': 'Moment de remise',
  'home.yourTools': 'Vos outils',
  'home.yourToolsRide': 'Vos outils',
  'home.swapSafely': 'Échangez en toute sécurité où que commence votre itinéraire.',
  'home.jumpBack': 'Revenez à vos demandes et voyages.',
  'home.jumpBackRide': 'Revenez à vos demandes de trajet et annonces.',
  'home.meetUpCurbside': 'Rencontrez-vous au bord du trottoir, à l\'aéroport ou devant la voiture de votre voyageur. FlexySwap connecte les expéditeurs et les voyageurs avec des identités vérifiées et un chat en direct, pour que chaque échange de colis soit aussi facile qu\'une remise amicale.',
  'home.reviewPending': 'Examinez les échanges en attente, suivez les paiements et coordonnez de nouveaux itinéraires directement depuis les consoles que vous utilisez déjà.',
  'home.reviewPendingRide': 'Examinez les demandes de trajet en attente, suivez les gains et coordonnez de nouveaux itinéraires directement depuis les consoles que vous utilisez déjà.',
  'home.findTraveler': 'Trouver un voyageur',
  'home.viewMyTrips': 'Voir mes voyages',
  'home.viewMyRides': 'Voir mes trajets',
  'home.offerToCarry': 'Offrir de transporter',
  'home.manageRequests': 'Gérer les demandes',
  'home.manageRideRequests': 'Gérer les demandes de trajet',
  'home.mobileApp': 'Application mobile',
  'home.takeFlexySwap': 'Emportez FlexySwap avec vous',
  'home.downloadApp': 'Téléchargez notre application mobile et gérez vos voyages, demandes et livraisons de n\'importe où.',
  'home.dateAndTime': 'Date et heure',
  'home.resultsWithinDays': 'Les résultats incluront les voyages dans les ±3 jours de la date sélectionnée.',
  'home.signInToFindTrips': 'Connectez-vous pour trouver des voyages',
  'home.findTrips': 'Trouver des voyages',
  'home.from': 'De',
  'home.to': 'À',
  'home.fromPlaceholder': 'Aéroport, gare routière, hôtel...',
  'home.toPlaceholder': 'Point de dépôt',

  // Sender Trips (web sender console)
  'senderTrips.title': 'Console expéditeur',
  'senderTrips.subtitle': 'Où devez-vous envoyer un colis ?',
  'senderTrips.ctaLabel': 'Rechercher des voyageurs',
  'senderTrips.showAllOnMap': 'Afficher tous les voyages sur la carte',
  'senderTrips.seeActiveTravelers': 'Voir les voyageurs actifs ci-dessous',
  'senderTrips.signInTitle': 'Connectez-vous pour voir vos voyageurs',
  'senderTrips.signInDescription': 'Utilisez vos identifiants FlexySwap pour charger les voyages synchronisés depuis l\'application mobile.',
  'senderTrips.emptyTitle': 'Aucun voyageur actif pour le moment.',
  'senderTrips.emptySubtitle': 'Vous pouvez garder l\'échange actif — créez une demande de livraison ou listez un voyage.',
  'senderTrips.createRequest': 'Créer une demande de livraison',
  'senderTrips.listNewTrip': 'Lister un nouveau voyage',
  'senderTrips.primaryAction': 'Demander',
  'senderTrips.secondaryAction': 'Voir les détails',
  'senderTrips.mapTitle': 'Vue carte des annonces expéditeur',
  'senderTrips.disableOwn': 'Cette annonce vous appartient',
  'senderTrips.disableAlreadyRequested': 'Vous avez déjà envoyé une demande pour cette annonce',

  // Traveler Trips (web traveler console)
  'travelerTrips.title': 'Console voyageur',
  'travelerTrips.subtitle': 'Où voyagez-vous ?',
  'travelerTrips.ctaLabel': 'Rechercher des expéditeurs',
  'travelerTrips.showAllOnMap': 'Afficher tous les voyages sur la carte',
  'travelerTrips.seeActiveSenders': 'Voir les expéditeurs actifs ci-dessous',
  'travelerTrips.signInTitle': 'Connectez-vous pour voir les expéditeurs',
  'travelerTrips.signInDescription': 'Les données FlexySwap de l\'application mobile sont disponibles une fois connecté avec votre compte existant.',
  'travelerTrips.emptyTitle': 'Aucune demande d\'expéditeur pour le moment.',
  'travelerTrips.emptySubtitle': 'Vous pouvez toujours garder l\'échange actif — publiez un voyage ou demandez une livraison.',
  'travelerTrips.listNewTrip': 'Lister un nouveau voyage',
  'travelerTrips.createRequest': 'Créer une demande de livraison',
  'travelerTrips.primaryAction': 'Envoyer une offre',
  'travelerTrips.secondaryAction': 'Voir les détails',
  'travelerTrips.mapTitle': 'Vue carte des annonces voyageur',
  'travelerTrips.disableOwn': 'Cette annonce vous appartient',
  'travelerTrips.disableAlreadyRequested': 'Vous avez déjà envoyé une demande pour cette annonce',

  // Trip result cards
  'tripCard.capacityLeft': 'Capacité restante :',
  'tripCard.price': 'Prix :',
  'tripCard.material': 'Matériau :',
  'tripCard.deliveryMethod': 'Méthode de livraison :',
  'tripCard.contactForPrice': 'Contacter pour le prix',
  'tripCard.scheduleTbd': 'Horaire à confirmer',
  'tripCard.flexyUser': 'Utilisateur Flexy',

  // Trip detail page
  'tripDetail.tripIdNotFound': 'ID de voyage introuvable',
  'tripDetail.tripNotFound': 'Voyage introuvable',
  'tripDetail.failedToLoad': 'Échec du chargement des détails du voyage',
  'tripDetail.notFoundDescription': 'Le voyage que vous recherchez n\'existe pas ou a été supprimé.',
  'tripDetail.loading': 'Chargement des détails du voyage...',
  'tripDetail.unverified': 'Non vérifié',
  'tripDetail.reviews': '({{count}} avis)',
  'tripDetail.completedTrips': '{{count}} voyages terminés',
  'tripDetail.viewProfile': 'Voir le profil',
  'tripDetail.senderDeliveries': 'Livraisons en tant qu\'expéditeur',
  'tripDetail.travelerDeliveries': 'Livraisons en tant que voyageur',
  'tripDetail.sendOffer': 'Envoyer une offre',
  'tripDetail.requestDelivery': 'Demander une livraison',
  'tripDetail.tripInformation': 'Informations sur le voyage',
  'tripDetail.route': 'Itinéraire',
  'tripDetail.departure': 'Départ',
  'tripDetail.atTime': 'à {{time}}',
  'tripDetail.tripDetails': 'Détails du voyage',
  'tripDetail.tripType': 'Type de voyage',
  'tripDetail.lookingForSpace': 'Recherche d\'espace',
  'tripDetail.offeringShipping': 'Propose une livraison',
  'tripDetail.materialType': 'Type de matériau',
  'tripDetail.deliveryMethod': 'Méthode de livraison',
  'tripDetail.spaceNeeded': 'Espace nécessaire',
  'tripDetail.capacityAvailable': 'Capacité disponible',
  'tripDetail.itemDescription': 'Description de l\'article',
  'tripDetail.notesAndRules': 'Notes et règles',
  'tripDetail.securePaymentProtection': 'Protection des paiements sécurisés',
  'tripDetail.securePaymentText': 'Les paiements sont conservés en toute sécurité jusqu\'à ce que la livraison soit confirmée. Votre argent est en sécurité avec FlexySwap.',

  // Chat
  'chat.title': 'Messages',
  'chat.searchPlaceholder': 'Rechercher dans les conversations...',
  'chat.noConversations': 'Aucune conversation pour le moment',
  'chat.noMessagesYet': 'Aucun message pour le moment',
  'chat.noMessagesStart': 'Aucun message pour le moment. Commencez la conversation !',
  'chat.online': 'En ligne',
  'chat.offline': 'Hors ligne',
  'chat.seenRecently': 'Vu récemment',
  'chat.minutesAgo': 'il y a {{count}} min',
  'chat.hoursAgo': 'il y a {{count}} h',
  'chat.daysAgo': 'il y a {{count}} j',
  'chat.typing': 'Saisie en cours...',
  'chat.photo': 'Photo',
  'chat.file': 'Fichier',
  'chat.sending': 'Envoi...',
  'chat.send': 'Envoyer',
  'chat.replyToMessage': 'Répondre au message',
  'chat.repliedTo': 'Réponse à :',
  'chat.replyingTo': 'Vous répondez à :',
  'chat.inputPlaceholder': 'Envoyer un message...',
  'chat.blockedByUser': 'Vous êtes bloqué par cet utilisateur',
  'chat.blockedUser': 'Vous avez bloqué cet utilisateur',
  'chat.selectConversation': 'Sélectionnez une conversation pour commencer à discuter',
  'chat.replyToMessageModalTitle': 'Répondre au message',
  'chat.originalMessage': 'Message original :',
  'chat.replyPlaceholder': 'Tapez votre réponse...',
  'chat.cancel': 'Annuler',
  'chat.reply': 'Répondre',
  'chat.thisUser': 'cet utilisateur',
  'chat.confirmDeleteConversation': 'Voulez-vous vraiment supprimer cette conversation ?',
  'chat.failedDeleteConversation': 'Échec de la suppression de la conversation',
  'chat.confirmBlockUser': 'Voulez-vous vraiment bloquer {{name}} ?',
  'chat.confirmUnblockUser': 'Voulez-vous vraiment débloquer {{name}} ?',
  'chat.confirmReportUser': 'Voulez-vous vraiment signaler {{name}} ?',
  'chat.userReported': 'Utilisateur signalé avec succès',

  // Request Delivery
  'requestDelivery.editRequest': 'Modifier la demande',
  'requestDelivery.requestDelivery': 'Demander une livraison',
  'requestDelivery.updateYourDeliveryRequest': 'Mettre à jour votre demande de livraison',
  'requestDelivery.sendPackagesWorldwide': 'Envoyez des colis dans le monde entier avec des voyageurs de confiance.',
  'requestDelivery.captureYourRoute': 'Capturez votre itinéraire, votre fenêtre de ramassage et les détails du colis une fois. FlexySwap vous met en relation avec des voyageurs vérifiés qui ont de l\'espace de bagages supplémentaire, protégés par des paiements en dépôt et un chat dans l\'application.',
  'requestDelivery.airportCityHandoffs': 'Remises à l\'aéroport et en ville',
  'requestDelivery.photoProofOnDelivery': 'Preuve photo à la livraison',
  'requestDelivery.viewMyRequests': 'Voir mes demandes',
  'requestDelivery.browseTravelerRoutes': 'Parcourir les itinéraires des voyageurs',
  'requestDelivery.avgPickupTime': 'Temps de ramassage moyen',
  'requestDelivery.verifiedTravelers': 'Voyageurs vérifiés',
  'requestDelivery.routesWeekly': 'Itinéraires hebdomadaires',
  'requestDelivery.stepOf': 'Étape {{current}} sur {{total}}',
  'requestDelivery.routeDestination': 'Itinéraire et destination',
  'requestDelivery.searchOriginAddress': 'Rechercher l\'adresse d\'origine',
  'requestDelivery.searchDestinationAddress': 'Rechercher l\'adresse de destination',
  'requestDelivery.departure': 'Départ',
  'requestDelivery.date': 'Date',
  'requestDelivery.time': 'Heure',
  'requestDelivery.selectDepartureDate': 'Sélectionner la date de départ',
  'requestDelivery.selectDepartureTime': 'Sélectionner l\'heure de départ',
  'requestDelivery.itemDescription': 'Description de l\'article',
  'requestDelivery.describeItems': 'Décrivez les articles que vous souhaitez envoyer',
  'requestDelivery.itemDescriptionPlaceholder': 'ex: Documents, Électronique, Vêtements...',
  'requestDelivery.spaceNeeded': 'Espace nécessaire',
  'requestDelivery.enterAmount': 'Entrer le montant',
  'requestDelivery.additionalInformation': 'Informations supplémentaires',
  'requestDelivery.notesOptional': 'Notes (Optionnel)',
  'requestDelivery.notesPlaceholder': 'Toute instruction spéciale ou détail...',
  'requestDelivery.agreements': 'Accords',
  'requestDelivery.agreeToBeContacted': 'J\'accepte d\'être contacté via l\'application pour la coordination de la livraison',
  'requestDelivery.acceptTerms': 'J\'accepte les termes et conditions et la politique de confidentialité',
  'requestDelivery.summary': 'Résumé',
  'requestDelivery.route': 'Itinéraire',
  'requestDelivery.notes': 'Notes',
  'requestDelivery.back': 'Retour',
  'requestDelivery.next': 'Suivant',
  'requestDelivery.updating': 'Mise à jour...',
  'requestDelivery.creating': 'Création...',
  'requestDelivery.updateRequest': 'Mettre à jour la demande',
  'requestDelivery.submitRequest': 'Soumettre la demande',
  'requestDelivery.departureDate': 'Date de départ',
  'requestDelivery.pickADay': 'Choisissez un jour qui correspond à votre itinéraire',
  'requestDelivery.useQuickSuggestions': 'Utilisez les suggestions rapides ou choisissez dans le calendrier ci-dessous.',
  'requestDelivery.quickPicks': 'Choix rapides',
  'requestDelivery.today': 'Aujourd\'hui',
  'requestDelivery.tomorrow': 'Demain',
  'requestDelivery.in3Days': 'Dans 3 jours',
  'requestDelivery.nextWeek': 'La semaine prochaine',
  'requestDelivery.calendar': 'Calendrier',
  'requestDelivery.cancel': 'Annuler',
  'requestDelivery.useThisDate': 'Utiliser cette date',
  'requestDelivery.departureTime': 'Heure de départ',
  'requestDelivery.chooseClearHandoffTime': 'Choisissez une heure de remise claire',
  'requestDelivery.tapHourThenMinutes': 'Appuyez sur une heure, puis les minutes. Terminez par une confirmation rapide.',
  'requestDelivery.manualAdjust': 'Ajustement manuel',
  'requestDelivery.hour': 'Heure',
  'requestDelivery.minutes': 'Minutes',
  'requestDelivery.adjustsInMinuteSteps': 'S\'ajuste par pas de {step} minutes',
  'requestDelivery.useThisTime': 'Utiliser cette heure',
  'requestDelivery.pleaseSelectBothAddresses': 'Veuillez sélectionner les adresses d\'origine et de destination',
  'requestDelivery.originDestinationCannotBeSame': 'L\'origine et la destination ne peuvent pas être identiques',
  'requestDelivery.pleaseSelectDateAndTime': 'Veuillez sélectionner la date et l\'heure de départ',
  'requestDelivery.pleaseDescribeItems': 'Veuillez décrire les articles que vous souhaitez envoyer',
  'requestDelivery.pleaseEnterValidSpace': 'Veuillez entrer un montant d\'espace valide',
  'requestDelivery.notesCannotExceed': 'Les notes ne peuvent pas dépasser 200 caractères',
  'requestDelivery.pleaseAcceptBothAgreements': 'Veuillez accepter les deux accords pour continuer',
  'requestDelivery.pleaseLogIn': 'Veuillez vous connecter pour créer une demande',
  'requestDelivery.requestUpdatedSuccessfully': 'Demande mise à jour avec succès!',
  'requestDelivery.requestCreatedSuccessfully': 'Demande créée avec succès!',
  'requestDelivery.failedToUpdateRequest': 'Échec de la mise à jour de la demande. Veuillez réessayer.',
  'requestDelivery.failedToCreateRequest': 'Échec de la création de la demande. Veuillez réessayer.',
  
  // Incoming Requests
  'incomingRequests.incomingRequests': 'Demandes entrantes',
  'incomingRequests.manageRequestsFromTravelers': 'Gérez les demandes des voyageurs pour vos annonces de livraison',
  'incomingRequests.noDeliveryListingsYet': 'Aucune annonce de livraison pour le moment',
  'incomingRequests.createDeliveryRequest': 'Créez une demande de livraison pour commencer à recevoir des demandes de voyageurs',
  'incomingRequests.createRequest': 'Créer une demande',
  'incomingRequests.route': 'Itinéraire',
  'incomingRequests.departure': 'Départ',
  'incomingRequests.itemDescription': 'Description de l\'article',
  'incomingRequests.spaceNeeded': 'Espace nécessaire',
  'incomingRequests.pending': 'En attente',
  'incomingRequests.accepted': 'Accepté',
  'incomingRequests.total': 'Total',
  'incomingRequests.done': 'Terminé',
  'incomingRequests.view': 'Voir',
  'incomingRequests.edit': 'Modifier',
  'incomingRequests.delete': 'Supprimer',
  'incomingRequests.completed': 'Terminé',
  'incomingRequests.notes': 'Notes',
  'incomingRequests.accept': 'Accepter',
  'incomingRequests.reject': 'Rejeter',
  'incomingRequests.areYouSureReject': 'Êtes-vous sûr de vouloir rejeter cette demande?',
  'incomingRequests.requestRejected': 'Demande rejetée.',
  'incomingRequests.failedToRejectRequest': 'Échec du rejet de la demande. Veuillez réessayer.',
  'incomingRequests.requestAcceptedSuccessfully': 'Demande acceptée avec succès!',
  'incomingRequests.failedToAcceptRequest': 'Échec de l\'acceptation de la demande. Veuillez réessayer.',
  'incomingRequests.areYouSureDeleteTrip': 'Êtes-vous sûr de vouloir supprimer ce voyage? Cette action ne peut pas être annulée et supprimera également toutes les demandes associées.',
  'incomingRequests.tripDeletedSuccessfully': 'Voyage supprimé avec succès.',
  'incomingRequests.failedToDeleteTrip': 'Échec de la suppression du voyage. Veuillez réessayer.',
  'incomingRequests.pleaseLogInToView': 'Veuillez vous connecter pour voir vos demandes entrantes',
  'incomingRequests.goToLogin': 'Aller à la connexion',
  
  // My Requests
  'myRequests.myRequests': 'Mes demandes',
  'myRequests.viewAndManageRequests': 'Voir et gérer vos demandes de livraison aux voyageurs',
  'myRequests.noRequestsYet': 'Aucune demande pour le moment',
  'myRequests.haventSentAnyRequests': 'Vous n\'avez pas encore envoyé de demandes de livraison aux voyageurs',
  'myRequests.tripOwner': 'Propriétaire du voyage',
  'myRequests.item': 'Article',
  'myRequests.status.pending': 'En attente',
  'myRequests.status.accepted': 'Acceptée',
  'myRequests.status.rejected': 'Rejetée',
  'myRequests.status.completed': 'Terminée',
  'myRequests.status.delivered': 'Livrée',
  'myRequests.status.cancelled': 'Annulée',
  'myRequests.waitingForDelivery': 'En attente de livraison de {{name}}',
  'myRequests.confirmPayment': 'Confirmer le paiement',
  'myRequests.rate': 'Noter',
  'myRequests.reviewed': 'Noté',
  'myRequests.cancelRequest': 'Annuler la demande',
  'myRequests.message': 'Message',
  'myRequests.areYouSureCancel': 'Êtes-vous sûr de vouloir annuler cette demande?',
  'myRequests.requestCancelledSuccessfully': 'Demande annulée avec succès.',
  'myRequests.failedToCancelRequest': 'Échec de l\'annulation de la demande. Veuillez réessayer.',
  'myRequests.pleaseLogInToView': 'Veuillez vous connecter pour voir vos demandes',
  'myRequests.confirmPaymentTitle': 'Confirmer le paiement',
  'myRequests.hasReportedDelivered': '{{name}} a signalé que votre colis a été livré. Souhaitez-vous libérer le paiement?',
  'myRequests.subtotal': 'Sous-total',
  'myRequests.fees15': 'Frais (15%)',
  'myRequests.total': 'Total',
  'myRequests.no': 'Non',
  'myRequests.yes': 'Oui',
  'myRequests.paymentConfirmed': 'Paiement confirmé. Livraison terminée avec succès!',
  'myRequests.failedToConfirmPayment': 'Échec de la confirmation du paiement. Veuillez réessayer.',
  'myRequests.prev': 'Précédent',
  'myRequests.next': 'Suivant',
  'myRequests.thisTraveler': 'Ce voyageur',
  'myRequests.route': 'Itinéraire',
  'myRequests.departure': 'Départ',
  'myRequests.space': 'Espace',
  'myRequests.price': 'Prix',
  'myRequests.notes': 'Notes',
  
  // Traveler Trip Requests
  'travelerTripRequests.tripRequests': 'Demandes de voyage',
  'travelerTripRequests.manageRequestsForListing': 'Gérez les demandes pour votre annonce de voyage',
  'travelerTripRequests.backToIncomingRequests': 'Retour aux demandes entrantes',
  'travelerTripRequests.availableSpace': 'Espace disponible',
  'travelerTripRequests.requests': 'Demandes',
  'travelerTripRequests.noRequestsYetForTrip': 'Aucune demande pour ce voyage pour le moment',
  'travelerTripRequests.tripNotFound': 'Voyage introuvable',
  'travelerTripRequests.failedToLoadTrip': 'Échec du chargement du voyage',
  'travelerTripRequests.theTravelerIsOffering': 'Le voyageur propose de transporter votre colis "{{item}}" 📦',
  'travelerTripRequests.waitingForDelivery': 'En attente de livraison de {{name}}',
  'travelerTripRequests.waitingForYourConfirmation': 'En attente de votre confirmation',
  'travelerTripRequests.hasMarkedAsDelivered': '{{name}} {{email}} a marqué l\'article comme livré. Veuillez confirmer la réception.',
  'travelerTripRequests.confirmReceived': 'Confirmer la réception',
  'travelerTripRequests.contact': 'Contacter',
  'travelerTripRequests.requestCompletedSuccessfully': 'Demande terminée avec succès!',
  'travelerTripRequests.confirmPaymentTitle': 'Confirmer le paiement',
  'travelerTripRequests.hasReportedDelivered': '{{name}} a signalé que votre colis a été livré. Souhaitez-vous libérer le paiement?',
  'travelerTripRequests.subtotal': 'Sous-total',
  'travelerTripRequests.fees15': 'Frais (15%)',
  'travelerTripRequests.total': 'Total',
  'travelerTripRequests.no': 'Non',
  'travelerTripRequests.yes': 'Oui',
  'travelerTripRequests.paymentConfirmed': 'Paiement confirmé. Livraison terminée avec succès!',
  'travelerTripRequests.failedToConfirmPayment': 'Échec de la confirmation du paiement. Veuillez réessayer.',
  'travelerTripRequests.pleaseLogInToReview': 'Veuillez vous connecter pour soumettre une évaluation.',
  'travelerTripRequests.requesterInfoMissing': 'Les informations sur le demandeur sont manquantes.',
  'travelerTripRequests.rejectRequest': 'Rejeter la demande',
  'travelerTripRequests.acceptRequest': 'Accepter la demande',
  'travelerTripRequests.areYouSureReject': 'Êtes-vous sûr de vouloir rejeter cette demande? Cette action ne peut pas être annulée.',
  'travelerTripRequests.areYouSureAccept': 'Êtes-vous sûr de vouloir accepter cette demande?',
  'travelerTripRequests.reject': 'Rejeter',
  'travelerTripRequests.accept': 'Accepter',
  'travelerTripRequests.cancel': 'Annuler',
  'travelerTripRequests.requestAcceptedSuccessfully': 'Demande acceptée avec succès!',
  'travelerTripRequests.otherRequestsAutomaticallyRejected': '{count} autre(s) demande(s) automatiquement rejetée(s).',
  'travelerTripRequests.failedToAcceptRequest': 'Échec de l\'acceptation de la demande. Veuillez réessayer.',
  'travelerTripRequests.requestRejected': 'Demande rejetée.',
  'travelerTripRequests.failedToRejectRequest': 'Échec du rejet de la demande. Veuillez réessayer.',
  'travelerTripRequests.spaceNeeded': 'Espace nécessaire',
  'travelerTripRequests.price': 'Prix',
  'travelerTripRequests.deliveryMethod': 'Méthode de livraison',
  'travelerTripRequests.byRoad': 'Par route',
  'travelerTripRequests.byRail': 'Par rail',
  'travelerTripRequests.byAir': 'Par avion',
  'travelerTripRequests.notes': 'Notes',
  'travelerTripRequests.item': 'Article',
  'travelerTripRequests.thisItem': 'cet article',
  'travelerTripRequests.departure': 'Départ',
  
  // Navbar
  'nav.trips': 'Voyages',
  'nav.driver': 'Conducteur',
  'nav.passenger': 'Passager',
  'nav.asSender': 'En tant qu\'expéditeur',
  'nav.asTraveler': 'En tant que voyageur',
  'nav.imASender': 'Je suis un expéditeur',
  'nav.imATraveler': 'Je suis un voyageur',
  'nav.imAPassenger': 'Je suis un passager',
  'nav.imADriver': 'Je suis un conducteur',
  'nav.searchTravelersSendPackages': 'Rechercher des voyageurs et envoyer des colis',
  'nav.listTripsEarnMoney': 'Lister des voyages et gagner de l\'argent',
  'nav.seeDriverSeatListings': 'Voir les annonces de sièges de conducteur',
  'nav.seePassengerRideRequests': 'Voir les demandes de trajet de passager',
  'nav.flexyRide': 'Flexy Ride',
  'nav.browseAsSender': 'Parcourir en tant qu\'expéditeur',
  'nav.browseAsTraveler': 'Parcourir en tant que voyageur',
  'nav.browseAsDriver': 'Parcourir en tant que conducteur',
  'nav.browseAsPassenger': 'Parcourir en tant que passager',
  'nav.welcomeBack': 'Bon retour',
  'nav.createAccount': 'Créer un compte',
  'nav.mySeatListings': 'Mes annonces de sièges',
  'nav.viewAndManageYourSeatListings': 'Voir et gérer vos annonces de sièges',
  'nav.myRequests': 'Mes demandes',
  'nav.viewYourSeatRequests': 'Voir vos demandes de sièges',
  'nav.createSeatListing': 'Créer une annonce de siège',
  'nav.listANewSeat': 'Lister un nouveau siège',
  'nav.myPassengerListings': 'Mes annonces de passager',
  'nav.viewAndManageYourPassengerListings': 'Voir et gérer vos annonces de passager',
  'nav.myApplications': 'Mes candidatures',
  'nav.viewYourPassengerApplications': 'Voir vos candidatures de passager',
  'nav.createPassengerListing': 'Créer une annonce de passager',
  'nav.createANewPassengerListing': 'Créer une nouvelle annonce de passager',
  
  // Traveler My Requests
  'travelerMyRequests.myRequests': 'Mes demandes',
  'travelerMyRequests.viewAndManageRequests': 'Voir et gérer vos demandes de livraison aux expéditeurs',
  'travelerMyRequests.noRequestsYet': 'Aucune demande pour le moment',
  'travelerMyRequests.haventSentAnyRequests': 'Vous n\'avez pas encore envoyé de demandes de livraison aux expéditeurs',
  'travelerMyRequests.browseSenderListings': 'Parcourir les annonces d\'expéditeurs',
  'travelerMyRequests.pleaseLogInToView': 'Veuillez vous connecter pour voir vos demandes',
  'travelerMyRequests.goToLogin': 'Aller à la connexion',
  'travelerMyRequests.tripOwner': 'Propriétaire du voyage',
  'travelerMyRequests.item': 'Article',
  'travelerMyRequests.route': 'Itinéraire',
  'travelerMyRequests.departure': 'Départ',
  'travelerMyRequests.space': 'Espace',
  'travelerMyRequests.price': 'Prix',
  'travelerMyRequests.notes': 'Notes',
  'travelerMyRequests.delivery': 'Livraison',
  'travelerMyRequests.deliveryInProgress': 'Livraison en cours',
  'travelerMyRequests.markAsDelivered': 'Marquer comme livré',
  'travelerMyRequests.cancelRequest': 'Annuler la demande',
  'travelerMyRequests.message': 'Message',
  'travelerMyRequests.rate': 'Noter',
  'travelerMyRequests.reviewed': 'Noté',
  'travelerMyRequests.waitingForSenderConfirmation': 'En attente de la confirmation de paiement et de réception de l\'expéditeur...',
  'travelerMyRequests.areYouSureCancel': 'Êtes-vous sûr de vouloir annuler cette demande ?',
  'travelerMyRequests.requestCancelledSuccessfully': 'Demande annulée avec succès.',
  'travelerMyRequests.failedToCancelRequest': 'Échec de l\'annulation de la demande. Veuillez réessayer.',
  'travelerMyRequests.markAsDeliveredConfirm': 'Marquer cet article comme livré ?',
  'travelerMyRequests.itemMarkedAsDelivered': 'Article marqué comme livré. En attente de la confirmation de l\'expéditeur.',
  'travelerMyRequests.failedToMarkAsDelivered': 'Échec du marquage comme livré. Veuillez réessayer.',
  'travelerMyRequests.pleaseLogInToRate': 'Veuillez vous connecter pour noter d\'autres utilisateurs.',
  'travelerMyRequests.tripOwnerInfoMissing': 'Les informations du propriétaire du voyage sont manquantes.',
  'travelerMyRequests.alreadyReviewed': 'Vous avez déjà noté cet utilisateur.',
  'travelerMyRequests.failedToOpenReviewModal': 'Échec de l\'ouverture de la fenêtre d\'évaluation. Veuillez réessayer.',
  'travelerMyRequests.prev': 'Préc.',
  'travelerMyRequests.next': 'Suiv.',
  
  // Sender Trip Requests
  'senderTripRequests.tripRequests': 'Demandes de voyage',
  'senderTripRequests.manageRequestsForListing': 'Gérer les demandes pour votre annonce de livraison',
  'senderTripRequests.backToMyListings': 'Retour à mes annonces',
  'senderTripRequests.tripNotFound': 'Voyage introuvable',
  'senderTripRequests.failedToLoadTrip': 'Échec du chargement du voyage',
  'senderTripRequests.route': 'Itinéraire',
  'senderTripRequests.departure': 'Départ',
  'senderTripRequests.itemDescription': 'Description de l\'article',
  'senderTripRequests.requests': 'Demandes',
  'senderTripRequests.pending': 'En attente',
  'senderTripRequests.accepted': 'Accepté',
  'senderTripRequests.noRequestsYetForTrip': 'Aucune demande pour ce voyage pour le moment',
  'senderTripRequests.item': 'Article',
  'senderTripRequests.spaceNeeded': 'Espace nécessaire',
  'senderTripRequests.price': 'Prix',
  'senderTripRequests.notes': 'Notes',
  'senderTripRequests.accept': 'Accepter',
  'senderTripRequests.reject': 'Rejeter',
  'senderTripRequests.contactTraveler': 'Contacter le voyageur',
  'senderTripRequests.contact': 'Contacter',
  'senderTripRequests.rate': 'Noter',
  'senderTripRequests.reviewed': 'Noté',
  'senderTripRequests.theSenderRequests': 'L\'expéditeur demande que vous transportiez le colis "{{item}}" 📦',
  'senderTripRequests.thisItem': 'cet article',
  'senderTripRequests.requestAccepted': 'Demande acceptée. En attente de livraison...',
  'senderTripRequests.markAsDelivered': 'Marquer comme livré',
  'senderTripRequests.confirmReceivedApprovalPending': 'L\'approbation de confirmation de réception est en attente',
  'senderTripRequests.requestCompletedSuccessfully': 'Demande terminée avec succès !',
  'senderTripRequests.rejectRequest': 'Rejeter la demande',
  'senderTripRequests.acceptRequest': 'Accepter la demande',
  'senderTripRequests.areYouSureReject': 'Êtes-vous sûr de vouloir rejeter cette demande ? Cette action ne peut pas être annulée.',
  'senderTripRequests.areYouSureAccept': 'Êtes-vous sûr de vouloir accepter cette demande ?',
  'senderTripRequests.cancel': 'Annuler',
  'senderTripRequests.requestAcceptedSuccessfully': 'Demande acceptée avec succès !',
  'senderTripRequests.otherRequestsAutomaticallyRejected': '{count} autre(s) demande(s) automatiquement rejetée(s).',
  'senderTripRequests.failedToAcceptRequest': 'Échec de l\'acceptation de la demande. Veuillez réessayer.',
  'senderTripRequests.requestRejected': 'Demande rejetée.',
  'senderTripRequests.failedToRejectRequest': 'Échec du rejet de la demande. Veuillez réessayer.',
  'senderTripRequests.itemMarkedAsDelivered': 'Article marqué comme livré. En attente de la confirmation de l\'expéditeur.',
  'senderTripRequests.failedToMarkAsDelivered': 'Échec du marquage comme livré. Veuillez réessayer.',
  'senderTripRequests.confirmPayment': 'Confirmer le paiement',
  'senderTripRequests.subtotal': 'Sous-total',
  'senderTripRequests.fees15': 'Frais (15%)',
  'senderTripRequests.total': 'Total',
  'senderTripRequests.paymentConfirmed': 'Paiement confirmé. Livraison terminée avec succès !',
  'senderTripRequests.failedToConfirmPayment': 'Échec de la confirmation du paiement. Veuillez réessayer.',
  'senderTripRequests.pleaseLogInToReview': 'Veuillez vous connecter pour soumettre une évaluation.',
  'senderTripRequests.travelerInfoMissing': 'Les informations du voyageur sont manquantes.',
  'senderTripRequests.alreadyReviewed': 'Vous avez déjà noté ce voyageur.',
  'senderTripRequests.failedToOpenReviewModal': 'Échec de l\'ouverture de la fenêtre d\'évaluation. Veuillez réessayer.',
  
  // List New Trip
  'listNewTrip.editTrip': 'Modifier le voyage',
  'listNewTrip.listNewTrip': 'Lister un nouveau voyage',
  'listNewTrip.updateTripDetails': 'Mettre à jour les détails de votre voyage',
  'listNewTrip.turnSpareLuggageSpace': 'Transformez l\'espace de bagage inutilisé en paiement instantané.',
  'listNewTrip.publishRouteDescription': 'Publiez votre itinéraire, votre fenêtre de ramassage et votre capacité de bagage en quelques minutes. FlexySwap vous associe à des expéditeurs vérifiés, garde les messages dans l\'application et libère le paiement une fois la livraison confirmée.',
  'listNewTrip.globalAirportNetwork': 'Réseau d\'aéroports mondial',
  'listNewTrip.escrowSecuredPayouts': 'Paiements sécurisés par séquestre',
  'listNewTrip.viewMyListings': 'Voir mes annonces',
  'listNewTrip.checkSenderRequests': 'Vérifier les demandes d\'expéditeurs',
  'listNewTrip.avgEarningsPerTrip': 'Gains moyens / voyage',
  'listNewTrip.communitySwaps': 'Échanges communautaires',
  'listNewTrip.routesListedWeekly': 'Itinéraires listés par semaine',
  'listNewTrip.stepOf': 'Étape {{current}} sur {{total}}',
  'listNewTrip.routeDestination': 'Itinéraire et destination',
  'listNewTrip.searchOriginAddress': 'Rechercher l\'adresse d\'origine',
  'listNewTrip.searchDestinationAddress': 'Rechercher l\'adresse de destination',
  'listNewTrip.departure': 'Départ',
  'listNewTrip.date': 'Date',
  'listNewTrip.time': 'Heure',
  'listNewTrip.selectDepartureDate': 'Sélectionner la date de départ',
  'listNewTrip.selectDepartureTime': 'Sélectionner l\'heure de départ',
  'listNewTrip.deliveryMethod': 'Méthode de livraison',
  'listNewTrip.byRail': 'Par rail',
  'listNewTrip.byAir': 'Par avion',
  'listNewTrip.byRoad': 'Par route',
  'listNewTrip.availableSpace': 'Espace disponible',
  'listNewTrip.spaceNeeded': 'Espace nécessaire',
  'listNewTrip.enterAmount': 'Entrer le montant',
  'listNewTrip.pricing': 'Tarification',
  'listNewTrip.pricingMode': 'Mode de tarification',
  'listNewTrip.perUnit': 'Par unité',
  'listNewTrip.flatPrice': 'Prix fixe',
  'listNewTrip.pricePerUnit': 'Prix par unité (USD)',
  'listNewTrip.enterPricePerUnit': 'Entrer le prix par unité',
  'listNewTrip.flatPriceUsd': 'Prix fixe (USD)',
  'listNewTrip.enterFlatPrice': 'Entrer le prix fixe',
  'listNewTrip.additionalInformation': 'Informations supplémentaires',
  'listNewTrip.notesOptional': 'Notes (optionnel)',
  'listNewTrip.anySpecialInstructions': 'Toute instruction ou détail spécial...',
  'listNewTrip.agreements': 'Accords',
  'listNewTrip.agreeToBeContacted': 'J\'accepte d\'être contacté via l\'application pour la coordination de la livraison',
  'listNewTrip.acceptTerms': 'J\'accepte les conditions générales et la politique de confidentialité',
  'listNewTrip.summary': 'Résumé',
  'listNewTrip.route': 'Itinéraire',
  'listNewTrip.deliveryMethod': 'Méthode de livraison',
  'listNewTrip.availableSpace': 'Espace disponible',
  'listNewTrip.pricing': 'Tarification',
  'listNewTrip.notes': 'Notes',
  'listNewTrip.back': 'Retour',
  'listNewTrip.next': 'Suivant',
  'listNewTrip.updating': 'Mise à jour...',
  'listNewTrip.creating': 'Création...',
  'listNewTrip.updateTrip': 'Mettre à jour le voyage',
  'listNewTrip.submitRequest': 'Soumettre la demande',
  'listNewTrip.departureDate': 'Date de départ',
  'listNewTrip.pickWhenYouWillTravel': 'Choisissez quand vous voyagerez',
  'listNewTrip.quickSuggestionsKeepItSimple': 'Les suggestions rapides gardent les choses simples, ou utilisez le calendrier.',
  'listNewTrip.quickPicks': 'Choix rapides',
  'listNewTrip.today': 'Aujourd\'hui',
  'listNewTrip.tomorrow': 'Demain',
  'listNewTrip.in3Days': 'Dans 3 jours',
  'listNewTrip.nextWeek': 'La semaine prochaine',
  'listNewTrip.calendar': 'Calendrier',
  'listNewTrip.cancel': 'Annuler',
  'listNewTrip.useThisDate': 'Utiliser cette date',
  'listNewTrip.departureTime': 'Heure de départ',
  'listNewTrip.setClearTakeoffTime': 'Définir une heure de décollage claire',
  'listNewTrip.tapHourChooseMinutes': 'Appuyez sur l\'heure, choisissez les minutes, puis confirmez ci-dessous.',
  'listNewTrip.manualAdjust': 'Ajustement manuel',
  'listNewTrip.hour': 'Heure',
  'listNewTrip.minutes': 'Minutes',
  'listNewTrip.adjustsInMinuteSteps': 'S\'ajuste par pas de {step} minutes',
  'listNewTrip.useThisTime': 'Utiliser cette heure',
  'listNewTrip.pleaseSelectBothAddresses': 'Veuillez sélectionner les adresses d\'origine et de destination',
  'listNewTrip.originDestinationCannotBeSame': 'L\'origine et la destination ne peuvent pas être identiques',
  'listNewTrip.pleaseSelectDateAndTime': 'Veuillez sélectionner la date et l\'heure de départ',
  'listNewTrip.pleaseSelectDeliveryMethod': 'Veuillez sélectionner une méthode de livraison',
  'listNewTrip.pleaseEnterValidSpace': 'Veuillez entrer un montant d\'espace valide',
  'listNewTrip.pleaseEnterValidPricePerUnit': 'Veuillez entrer un prix par unité valide',
  'listNewTrip.pleaseEnterValidFlatPrice': 'Veuillez entrer un prix fixe valide',
  'listNewTrip.notesCannotExceed': 'Les notes ne peuvent pas dépasser 200 caractères',
  'listNewTrip.pleaseAcceptBothAgreements': 'Veuillez accepter les deux accords pour continuer',
  'listNewTrip.pleaseLogInToCreateTrip': 'Veuillez vous connecter pour créer un voyage',
  'listNewTrip.tripUpdatedSuccessfully': 'Voyage mis à jour avec succès !',
  'listNewTrip.tripListedSuccessfully': 'Voyage listé avec succès !',
  'listNewTrip.failedToUpdateTrip': 'Échec de la mise à jour du voyage. Veuillez réessayer.',
  'listNewTrip.failedToCreateTrip': 'Échec de la création du voyage. Veuillez réessayer.',
  
  // My Listings
  'myListings.myListings': 'Mes annonces',
  'myListings.manageTravelListings': 'Gérez vos annonces de voyage et consultez les demandes entrantes',
  'myListings.noListingsYet': 'Aucune annonce pour le moment',
  'myListings.createNewTripListing': 'Créez une nouvelle annonce de voyage pour commencer à recevoir des demandes de livraison',
  'myListings.listNewTrip': 'Lister un nouveau voyage',
  'myListings.pleaseLogInToView': 'Veuillez vous connecter pour voir vos annonces',
  'myListings.goToLogin': 'Aller à la connexion',
  'myListings.completed': 'Terminé',
  'myListings.route': 'Itinéraire',
  'myListings.departure': 'Départ',
  'myListings.pricing': 'Tarification',
  'myListings.available': 'Disponible',
  'myListings.pending': 'En attente',
  'myListings.accepted': 'Accepté',
  'myListings.total': 'Total',
  'myListings.done': 'Fait',
  'myListings.view': 'Voir',
  'myListings.edit': 'Modifier',
  'myListings.delete': 'Supprimer',
  'myListings.areYouSureDeleteTrip': 'Êtes-vous sûr de vouloir supprimer ce voyage ? Cette action ne peut pas être annulée et supprimera également toutes les demandes associées.',
  'myListings.tripDeletedSuccessfully': 'Voyage supprimé avec succès.',
  'myListings.failedToDeleteTrip': 'Échec de la suppression du voyage. Veuillez réessayer.',
  'myListings.prev': 'Préc.',
  'myListings.next': 'Suiv.',

  // Edit Profile
  'editProfile.title': 'Modifier le profil',
  'editProfile.loginRequired': 'Vous devez être connecté pour mettre à jour vos informations.',
  'editProfile.loadError': 'Échec du chargement des détails de votre profil. Veuillez réessayer.',
  'editProfile.heroTitle': 'Modifiez votre profil',
  'editProfile.heroSubtitle': 'Mettez à jour vos informations personnelles, votre nom d\'utilisateur et votre mot de passe. Les changements s\'appliquent instantanément sur le mobile et le web.',
  'editProfile.firstName': 'Prénom',
  'editProfile.firstNamePlaceholder': 'Entrez votre prénom',
  'editProfile.lastName': 'Nom',
  'editProfile.lastNamePlaceholder': 'Entrez votre nom',
  'editProfile.username': 'Nom d\'utilisateur',
  'editProfile.usernamePlaceholder': 'Choisissez un identifiant unique',
  'editProfile.usernameHelp': 'Les noms d\'utilisateur sont uniques et visibles sur votre profil public.',
  'editProfile.email': 'E-mail',
  'editProfile.phone': 'Numéro de téléphone',
  'editProfile.phonePlaceholder': '+33 6 12 34 56 78',
  'editProfile.address': 'Adresse',
  'editProfile.addressPlaceholder': 'Entrez votre adresse complète',
  'editProfile.addressHelp': 'Votre adresse sera utilisée pour faire correspondre les trajets et coordonner les livraisons.',
  'editProfile.currentPassword': 'Mot de passe actuel',
  'editProfile.currentPasswordPlaceholder': 'Requis pour changer le mot de passe',
  'editProfile.newPassword': 'Nouveau mot de passe',
  'editProfile.newPasswordPlaceholder': 'Laissez vide pour garder le mot de passe actuel',
  'editProfile.confirmNewPassword': 'Confirmer le nouveau mot de passe',
  'editProfile.confirmNewPasswordPlaceholder': 'Saisissez à nouveau le mot de passe',
  'editProfile.currentPasswordRequired': 'Veuillez saisir votre mot de passe actuel pour le modifier.',
  'editProfile.passwordsMismatch': 'Les mots de passe ne correspondent pas.',
  'editProfile.passwordTooShort': 'Le nouveau mot de passe doit contenir au moins 6 caractères.',
  'editProfile.updateSuccess': 'Profil mis à jour avec succès.',
  'editProfile.usernameTaken': 'Ce nom d\'utilisateur est déjà utilisé. Veuillez en choisir un autre.',
  'editProfile.reauthRequired': 'Veuillez vous réauthentifier et réessayer de changer votre mot de passe.',
  'editProfile.updateErrorFallback': 'Échec de la mise à jour du profil. Veuillez réessayer.',
  'editProfile.saving': 'Enregistrement...',
  'editProfile.saveChanges': 'Enregistrer les modifications',

  // Profile
  'profile.sectionLabel': 'Profil',
  'profile.userFallback': 'Utilisateur',
  'profile.title': 'Profil',
  'profile.loginRequired': 'Veuillez vous connecter pour voir votre profil.',
  'profile.heroBadge': 'Mon profil',
  'profile.heroTitle': 'Bon retour, {{name}} !',
  'profile.travelerFallback': 'voyageur',
  'profile.heroSubtitle': 'Gardez vos informations à jour, consultez vos statistiques et gérez la vérification depuis un seul et même endroit.',
  'profile.memberSince': 'Membre depuis {{date}}',
  'profile.verification': 'Vérification',
  'profile.verified': 'Vérifié',
  'profile.pending': 'En attente',
  'profile.notVerified': 'Non vérifié',
  'profile.verifiedDescription': 'Votre identité a été confirmée.',
  'profile.pendingDescription': 'La vérification est en cours d\'examen.',
  'profile.notVerifiedDescription': 'Téléchargez des documents pour être vérifié.',
  'profile.averageRating': 'Note moyenne',
  'profile.reviewsCount': '{{count}} avis',
  'profile.senderCompleted': 'Terminé en tant qu\'expéditeur',
  'profile.travelerCompleted': 'Terminé en tant que voyageur',
  'profile.manage': 'Gérer',
  'profile.editProfile': 'Modifier le profil',
  'profile.editProfileDescription': 'Mettez à jour votre nom, votre nom d\'utilisateur, votre mot de passe et vos coordonnées.',
  'profile.publicView': 'Vue publique',
  'profile.viewProfile': 'Voir le profil',
  'profile.viewProfileDescription': 'Voyez ce que les autres utilisateurs voient, y compris les avis et les statistiques.',
  'profile.openWallet': 'Ouvrir le portefeuille',
  'profile.settingsAndLegal': 'Paramètres et mentions légales',
  'profile.notifications': 'Notifications',
  'profile.identityVerification': 'Vérification d\'identité',
  'profile.status': 'Statut',
  'profile.pendingReview': 'En cours de révision',
  'profile.rejected': 'Refusé',
  'profile.selectDocumentType': 'Sélectionnez le type de document',
  'profile.passport': 'Passeport',
  'profile.idCard': 'Carte d\'identité',
  'profile.driverLicence': 'Permis de conduire',
  'profile.frontSide': 'Face avant',
  'profile.backSide': 'Face arrière',
  'profile.clickToUploadFront': 'Cliquez pour téléverser la face avant',
  'profile.clickToUploadBack': 'Cliquez pour téléverser la face arrière',
  'profile.submitting': 'Envoi...',
  'profile.uploading': 'Téléversement...',
  'profile.submitForVerification': 'Soumettre pour vérification',
  'profile.loadingLatest': 'Chargement des dernières données...',
  'profile.supportTitle': 'Support',
  'profile.supportSubtitle': 'Dites-nous brièvement ce dont vous avez besoin et notre équipe répondra dès que possible.',
  'profile.supportLoginRequired': 'Vous devez être connecté pour contacter le support.',
  'profile.supportRequired': 'Veuillez saisir un sujet et un message.',
  'profile.supportSent': 'Votre message a été envoyé. Nous vous répondrons bientôt.',
  'profile.supportFailed': 'Échec de l\'envoi du message de support. Veuillez réessayer.',
  'profile.supportSubject': 'Sujet',
  'profile.supportSubjectPlaceholder': 'Titre court pour votre problème',
  'profile.supportMessage': 'Message',
  'profile.supportMessagePlaceholder': 'Décrivez votre question ou votre problème en détail',
  'profile.supportSending': 'Envoi...',
  'profile.supportSend': 'Envoyer le message',
  'profile.supportHistoryTitle': 'Vos demandes précédentes',
  'profile.supportHistoryLoading': 'Chargement...',
  'profile.supportHistoryEmpty': 'Vous n\'avez pas encore créé de demandes de support.',
  'profile.supportNewTicket': 'Créer une nouvelle demande de support',
  'profile.supportDetailNotFound': 'Cette demande de support est introuvable.',
  'profile.supportPendingReply': 'Notre équipe a reçu votre message et répondra bientôt.',
  'profile.supportReplyLabel': 'Réponse du support',
  'profile.supportFollowupPlaceholder': 'Écrivez un message de suivi concernant ce problème',
  'profile.user': 'Vous',
  'profile.driverVerification': 'Vérification du conducteur',
  'profile.driverVerificationNote': 'Si vous êtes conducteur, veuillez vérifier vos documents',
  'profile.driverVerificationStatus': 'Statut de vérification du conducteur',
  'profile.driverLicenseFront': 'Permis de conduire (recto)',
  'profile.driverLicenseBack': 'Permis de conduire (verso)',
  'profile.vehicleInsurance': 'Police d\'assurance véhicule',
  'profile.submitDriverVerification': 'Soumettre la vérification du conducteur',
  'profile.driverVerificationSubmitted': 'Vérification du conducteur soumise',
  'profile.pleaseSelectAllDriverFiles': 'Veuillez sélectionner tous les fichiers requis',
  'profile.verificationSubmitted': 'Vérification soumise',
  'profile.verificationFailed': 'Échec de la vérification',
  'profile.verificationRejected': 'Vérification refusée',
  'profile.pleaseResubmit': 'Veuillez resoumettre vos documents',
  'profile.selectDocumentTypeDesc': 'Veuillez d\'abord sélectionner un type de document',
  'profile.pleaseSelectFile': 'Veuillez sélectionner les fichiers recto et verso',
  'profile.uploadFile': 'Cliquez pour téléverser le fichier',
  'profile.remove': 'Supprimer',
  'profile.selectSource': 'Sélectionner la source',
  'profile.selectSourceDesc': 'Choisissez d\'où récupérer le fichier',
  'profile.fromGallery': 'Depuis la galerie',
  'profile.fromFiles': 'Depuis les fichiers',
  'profile.failedPickFile': 'Échec de la sélection du fichier',
  'profile.submitForApproval': 'Soumettre pour approbation',

  // Profile Detail
  'profileDetail.back': '← Retour',
  'profileDetail.memberSince': 'Membre depuis {{date}}',
  'profileDetail.noEmail': 'Aucun e-mail fourni',
  'profileDetail.rating': 'Note',
  'profileDetail.completedDeliveries': 'Livraisons terminées',
  'profileDetail.completedSenderTraveler': '{{sender}} en tant qu\'expéditeur • {{traveler}} en tant que voyageur',
  'profileDetail.about': 'À propos',
  'profileDetail.completedSender': 'Terminé (expéditeur)',
  'profileDetail.completedTraveler': 'Terminé (voyageur)',
  'profileDetail.recentReviews': 'Avis récents',
  'profileDetail.communitySays': 'Ce que dit la communauté',
  'profileDetail.backToProfile': 'Retour au profil',
  'profileDetail.noReviews': 'Aucun avis pour le moment.',
  'profileDetail.anonymous': 'Anonyme',
  'profileDetail.senderRole': 'Expéditeur',
  'profileDetail.travelerRole': 'Voyageur',

  // Settings - Privacy Policy
  'privacy.header': 'Politique de confidentialité',
  'privacy.title': 'Vos données, traitées avec soin',
  'privacy.effective': 'En vigueur depuis le 1er décembre 2025 — Questions ? E-mail',
  'privacy.overview.title': 'Aperçu',
  'privacy.overview.body1': 'Chez Flexy Group, nous accordons de l\'importance à votre vie privée. Cette page explique quelles informations nous collectons et comment nous les utilisons.',
  'privacy.overview.body2': 'Nous vous encourageons à lire ces détails attentivement afin d\'utiliser FlexySwap de la manière qui vous convient.',
  'privacy.collect.title': 'Informations que nous collectons',
  'privacy.collect.body1': 'Les détails de votre compte tels que votre nom, votre adresse e-mail, votre numéro de téléphone et votre photo de profil.',
  'privacy.collect.body2': 'Les informations de vérification (pièce d\'identité, selfie), les itinéraires de voyage, les descriptions de colis et les messages échangés dans l\'application.',
  'privacy.collect.body3': 'Les données d\'appareil et d\'utilisation, y compris l\'adresse IP, le type de navigateur et les pages que vous visitez, afin que nous puissions garder FlexySwap sécurisé.',
  'privacy.use.title': 'Comment nous utilisons les informations',
  'privacy.use.body1': 'Pour fournir et améliorer la plateforme FlexySwap, y compris faire correspondre les expéditeurs et les voyageurs et traiter les paiements.',
  'privacy.use.body2': 'Pour vérifier les utilisateurs, prévenir la fraude et maintenir la sécurité de notre communauté.',
  'privacy.use.body3': 'Pour communiquer avec vous au sujet des réservations, des mises à jour et des demandes d\'assistance.',
  'privacy.sharing.title': 'Partage et divulgation',
  'privacy.sharing.body1': 'Nous ne vendons pas vos informations personnelles.',
  'privacy.sharing.body2': 'Nous ne partageons des données avec des prestataires de services (par exemple Stripe pour les paiements, des partenaires de vérification d\'identité) que lorsque cela est nécessaire pour fournir le service ou respecter la loi.',

  // Settings - Terms of Service
  'terms.header': 'Conditions d\'utilisation',
  'terms.title': 'Connaître vos responsabilités',
  'terms.effective': 'En vigueur depuis le 1er décembre 2025 — Questions ? E-mail',
  'terms.acceptance.title': 'Acceptation des conditions',
  'terms.acceptance.body1': 'En créant un compte ou en utilisant FlexySwap, vous acceptez ces Conditions d\'utilisation et notre Politique de confidentialité.',
  'terms.acceptance.body2': 'Si vous ne pouvez pas accepter ces conditions, veuillez ne pas utiliser la plateforme.',
  'terms.service.title': 'Service FlexySwap',
  'terms.service.body1': 'FlexySwap met en relation des expéditeurs et des voyageurs. Nous ne sommes pas une société de messagerie et ne sommes pas responsables des objets transportés.',
  'terms.service.body2': 'Les expéditeurs et les voyageurs concluent leur propre accord ; FlexySwap fournit la technologie et le portefeuille en dépôt.',
  'terms.responsibilities.title': 'Responsabilités des utilisateurs',
  'terms.responsibilities.bullet1': 'Vous devez avoir au moins 18 ans et fournir des informations exactes.',
  'terms.responsibilities.bullet2': 'Les expéditeurs doivent décrire avec précision les colis et éviter les articles interdits.',
  'terms.responsibilities.bullet3': 'Les voyageurs doivent respecter les règles des compagnies aériennes et des douanes et livrer les colis en toute sécurité.',
  'terms.financial.title': 'Conditions financières',
  'terms.financial.bullet1': 'FlexySwap collecte les paiements via un compte séquestre et verse les fonds au voyageur après la livraison.',
  'terms.financial.bullet2': 'Les frais de service sont affichés avant la confirmation d\'une réservation et sont généralement non remboursables.',
  'terms.liability.title': 'Responsabilité',
  'terms.liability.body1': 'Dans la mesure maximale permise par la loi, FlexySwap n\'est pas responsable des dommages indirects ou consécutifs.',
  'terms.liability.body2': 'Notre responsabilité globale est limitée aux frais de service que vous avez payés au cours des trois derniers mois ou à 100 $ US.',

  // Settings page
  'settings.heroBadge': 'Paramètres du compte',
  'settings.heroTitle': 'Contrôlez votre expérience',
  'settings.heroSubtitle': 'Mettez à jour les préférences de langue, consultez les politiques légales et assurez-vous que FlexySwap se comporte comme prévu.',
  'settings.preferences': 'Préférences',
  'settings.language': 'Langue',
  'settings.languageDescription': 'Choisissez votre langue d\'interface par défaut. Nous nous en souviendrons lors de votre prochaine visite.',
  'settings.languageNote': '(Les traductions de l\'interface web arrivent bientôt.)',
  'settings.theme': 'Thème',
  'settings.themeDescription': 'Faites correspondre FlexySwap à votre environnement. Le mode sombre est plus reposant pour les yeux dans les environnements peu lumineux.',
  'settings.lightMode': 'Mode clair',
  'settings.darkMode': 'Mode sombre',
  'settings.themeNote': 'Nous enregistrons ce choix sur votre appareil afin que les visites futures conservent le même aspect.',
  'settings.legal': 'Mentions légales',
  'settings.policiesTitle': 'Politiques et accords',
  'settings.policiesDescription': 'Comprenez comment nous protégeons vos données et les règles qui maintiennent FlexySwap sûr.',
  'settings.privacyTitle': 'Politique de confidentialité',
  'settings.privacyPolicy': 'Politique de confidentialité',
  'settings.privacyDescription': 'Découvrez quelles données personnelles nous collectons et comment elles sont traitées.',
  'settings.termsTitle': 'Conditions d\'utilisation',
  'settings.termsOfService': 'Conditions d\'utilisation',
  'settings.termsDescription': 'Consultez vos droits et responsabilités lors de l\'utilisation de FlexySwap.',
  'settings.helpTitle': 'Besoin d\'aide supplémentaire ?',
  'settings.helpTextBefore': 'Écrivez-nous à tout moment à',
  'settings.helpTextAfter': 'ou contactez-nous via le centre d\'assistance intégré à l\'application.',
  'settings.openSupportChat': 'Ouvrir le chat d\'assistance',

  // Common actions
  'common.back': 'Retour',
  'common.next': 'Suivant',
  'common.confirm': 'Confirmer',

  // Flexy Ride - Create Passenger
  'flexyRidePassenger.validation.routeRequired': 'Veuillez remplir tous les champs obligatoires (départ, arrivée, sièges)',
  'flexyRidePassenger.validation.originDestinationSame': 'Le point de départ et la destination ne peuvent pas être identiques',
  'flexyRidePassenger.validation.seatsInvalid': 'Veuillez saisir un nombre de sièges valide',
  'flexyRidePassenger.validation.dateTimeRequired': 'Veuillez sélectionner à la fois la date et l\'heure',
  'flexyRidePassenger.validation.agreementsRequired': 'Veuillez accepter les deux accords pour continuer',
  'flexyRidePassenger.validation.loginRequired': 'Veuillez vous connecter pour créer une annonce',
  'flexyRidePassenger.successUpdate': 'Annonce mise à jour avec succès !',
  'flexyRidePassenger.successCreate': 'Annonce créée avec succès !',
  'flexyRidePassenger.errorGeneric': 'Échec de l\'enregistrement de l\'annonce. Veuillez réessayer.',
  'flexyRidePassenger.routeTitle': 'Créer une demande de trajet',
  'flexyRidePassenger.seats': 'Sièges',
  'flexyRidePassenger.seatsPlaceholder': 'Nombre de sièges',
  'flexyRidePassenger.preferencesTitle': 'Préférences',
  'flexyRidePassenger.smoking': 'Tabac',
  'flexyRidePassenger.pets': 'Animaux',
  'flexyRidePassenger.luggage': 'Bagages',
  'flexyRidePassenger.comfort': 'Confort',
  'flexyRidePassenger.no': 'Non',
  'flexyRidePassenger.yes': 'Oui',
  'flexyRidePassenger.flexible': 'Flexible',
  'flexyRidePassenger.dateTimeTitle': 'Date et heure',
  'flexyRidePassenger.date': 'Date',
  'flexyRidePassenger.time': 'Heure',
  'flexyRidePassenger.selectDate': 'Sélectionner une date',
  'flexyRidePassenger.selectTime': 'Sélectionner une heure',
  'flexyRidePassenger.noteLabel': 'Note (optionnel)',
  'flexyRidePassenger.notePlaceholder': 'Ajouter une note...',
  'flexyRidePassenger.summaryTitle': 'Récapitulatif',
  'flexyRidePassenger.summaryRoute': 'Itinéraire',
  'flexyRidePassenger.summaryDeparture': 'Départ',
  'flexyRidePassenger.summarySeats': 'Sièges',
  'flexyRidePassenger.summarySeatsValue': '{{count}} sièges demandés',
  'flexyRidePassenger.summaryPreferences': 'Préférences',
  'flexyRidePassenger.summaryPreferencesValue': 'Tabac : {{smoking}} • Animaux : {{pets}} • Bagages : {{luggage}} • Confort : {{comfort}}',
  'flexyRidePassenger.summaryNote': 'Note',
  'flexyRidePassenger.dateNotSet': 'Date non définie',
  'flexyRidePassenger.timeNotSet': 'Heure non définie',
  'flexyRidePassenger.agreeContact': 'Contact uniquement via l\'application',
  'flexyRidePassenger.agreePolicy': 'Accepter la politique sur les objets interdits',
  'flexyRidePassenger.creating': 'Création...',
  'flexyRidePassenger.updateListing': 'Mettre à jour l\'annonce',
  'flexyRidePassenger.create': 'Créer',
  'flexyRidePassenger.selectDateTitle': 'Sélectionner la date',
  'flexyRidePassenger.selectTimeTitle': 'Sélectionner l\'heure',

  // Flexy Ride - Create Seat
  'flexyRideSeat.validation.routeRequired': 'Veuillez remplir tous les champs obligatoires (départ, arrivée, sièges)',
  'flexyRideSeat.validation.originDestinationSame': 'Le point de départ et la destination ne peuvent pas être identiques',
  'flexyRideSeat.validation.seatsInvalid': 'Veuillez saisir un nombre de sièges valide',
  'flexyRideSeat.validation.carInfoRequired': 'Veuillez remplir toutes les informations sur le véhicule (marque, modèle, année)',
  'flexyRideSeat.validation.dateTimePriceRequired': 'Veuillez sélectionner la date, l\'heure et saisir le prix',
  'flexyRideSeat.validation.priceInvalid': 'Veuillez saisir un prix valide',
  'flexyRideSeat.validation.agreementsRequired': 'Veuillez accepter les deux accords pour continuer',
  'flexyRideSeat.validation.loginRequired': 'Veuillez vous connecter pour créer une annonce',
  'flexyRideSeat.successUpdate': 'Annonce mise à jour avec succès !',
  'flexyRideSeat.successCreate': 'Annonce créée avec succès !',
  'flexyRideSeat.errorGeneric': 'Échec de l\'enregistrement de l\'annonce. Veuillez réessayer.',
  'flexyRideSeat.routeTitle': 'Lister un nouvel itinéraire',
  'flexyRideSeat.seats': 'Sièges',
  'flexyRideSeat.seatsPlaceholder': 'Nombre de sièges',
  'flexyRideSeat.preferencesTitle': 'Préférences et informations véhicule',
  'flexyRideSeat.smoking': 'Tabac',
  'flexyRideSeat.pets': 'Animaux',
  'flexyRideSeat.luggage': 'Bagages',
  'flexyRideSeat.comfort': 'Confort',
  'flexyRideSeat.no': 'Non',
  'flexyRideSeat.yes': 'Oui',
  'flexyRideSeat.flexible': 'Flexible',
  'flexyRideSeat.carBrand': 'Marque du véhicule *',
  'flexyRideSeat.carBrandPlaceholder': 'ex. : Toyota',
  'flexyRideSeat.carModel': 'Modèle du véhicule *',
  'flexyRideSeat.carModelPlaceholder': 'ex. : Camry',
  'flexyRideSeat.carYear': 'Année du véhicule *',
  'flexyRideSeat.carYearPlaceholder': 'ex. : 2020',
  'flexyRideSeat.dateTimeTitle': 'Date, heure et prix',
  'flexyRideSeat.date': 'Date *',
  'flexyRideSeat.time': 'Heure *',
  'flexyRideSeat.selectDate': 'Sélectionner une date',
  'flexyRideSeat.selectTime': 'Sélectionner une heure',
  'flexyRideSeat.priceWithSeats': 'Prix ({{count}} sièges au total) *',
  'flexyRideSeat.pricePlaceholder': 'Entrer le prix',
  'flexyRideSeat.noteLabel': 'Note (optionnel)',
  'flexyRideSeat.notePlaceholder': 'Ajouter une note...',
  'flexyRideSeat.summaryTitle': 'Récapitulatif',
  'flexyRideSeat.summaryRoute': 'Itinéraire',
  'flexyRideSeat.summaryDeparture': 'Départ',
  'flexyRideSeat.summarySeatsPrice': 'Sièges et prix',
  'flexyRideSeat.summarySeatsPriceValue': '{{seats}} sièges • CAD ${{price}}',
  'flexyRideSeat.summaryPreferences': 'Préférences',
  'flexyRideSeat.summaryPreferencesValue': 'Tabac : {{smoking}} • Animaux : {{pets}} • Bagages : {{luggage}} • Confort : {{comfort}}',
  'flexyRideSeat.summaryVehicle': 'Véhicule',
  'flexyRideSeat.summaryNote': 'Note',
  'flexyRideSeat.dateNotSet': 'Date non définie',
  'flexyRideSeat.timeNotSet': 'Heure non définie',
  'flexyRideSeat.agreeContact': 'Contact uniquement via l\'application',
  'flexyRideSeat.agreePolicy': 'Accepter la politique sur les objets interdits',
  'flexyRideSeat.creating': 'Création...',
  'flexyRideSeat.updateListing': 'Mettre à jour l\'annonce',
  'flexyRideSeat.create': 'Créer',
  'flexyRideSeat.selectDateTitle': 'Sélectionner la date',
  'flexyRideSeat.selectTimeTitle': 'Sélectionner l\'heure',

  // Flexy Ride detail (passenger & seat)
  'flexyRideDetail.listingIdNotFound': 'ID d\'annonce introuvable',
  'flexyRideDetail.listingNotFound': 'Annonce introuvable',
  'flexyRideDetail.failedToLoadListing': 'Échec du chargement de l\'annonce',
  'flexyRideDetail.requestSent': 'Demande envoyée avec succès !',
  'flexyRideDetail.failedToSendRequest': 'Échec de l\'envoi de la demande. Veuillez réessayer.',
  'flexyRideDetail.applyOwnListing': 'Vous ne pouvez pas postuler à votre propre annonce.',
  'flexyRideDetail.alreadyApplied': 'Vous avez déjà envoyé une demande pour cette annonce.',
  'flexyRideDetail.backToListings': 'Retour aux annonces',
  'flexyRideDetail.verifiedPassenger': 'Passager vérifié',
  'flexyRideDetail.unverifiedPassenger': 'Passager non vérifié',
  'flexyRideDetail.verifiedDriver': 'Conducteur vérifié',
  'flexyRideDetail.unverifiedDriver': 'Conducteur non vérifié',
  'flexyRideDetail.passengerBadge': 'Flexy Ride • Annonce passager',
  'flexyRideDetail.seatBadge': 'Flexy Ride • Annonce siège',
  'flexyRideDetail.route': 'Itinéraire',
  'flexyRideDetail.preferredCar': 'Voiture préférée',
  'flexyRideDetail.passenger.applyLoginDriver': 'Veuillez vous connecter pour postuler en tant que conducteur.',
  'flexyRideDetail.seat.applyLoginSeat': 'Veuillez vous connecter pour postuler pour un siège.',
  'flexyRideDetail.passenger.messageLogin': 'Veuillez vous connecter pour envoyer un message au passager.',
  'flexyRideDetail.seat.messageLogin': 'Veuillez vous connecter pour envoyer un message au conducteur.',
  'flexyRideDetail.signInToApplyDriver': 'Connectez-vous pour postuler',
  'flexyRideDetail.signInToApplySeat': 'Connectez-vous pour postuler',
  'flexyRideDetail.applied': 'Demande envoyée',
  'flexyRideDetail.applyAsDriver': 'Postuler en tant que conducteur',
  'flexyRideDetail.applyForSeat': 'Postuler pour un siège',

  // Flexy Ride - My Applications
  'flexyRideApplications.title': 'Mes candidatures',
  'flexyRideApplications.subtitle':
    'Consultez et gérez vos candidatures aux trajets passagers',
  'flexyRideApplications.statusPending': 'En attente',
  'flexyRideApplications.statusAccepted': 'Acceptée',
  'flexyRideApplications.statusRejected': 'Refusée',
  'flexyRideApplications.statusCompleted': 'Terminée',
  'flexyRideApplications.statusCancelled': 'Annulée',
  'flexyRideApplications.statusUnknown': 'Inconnue',
  'flexyRideApplications.loginToRate':
    'Veuillez vous connecter pour noter les autres utilisateurs.',
  'flexyRideApplications.driverInfoMissing':
    'Les informations du conducteur sont manquantes.',
  'flexyRideApplications.alreadyReviewed':
    'Vous avez déjà évalué cet utilisateur.',
  'flexyRideApplications.driverFallback': 'Conducteur',
  'flexyRideApplications.reviewModalError':
    "Échec de l'ouverture de la fenêtre d'avis. Veuillez réessayer.",
  'flexyRideApplications.passengerLabel': 'Passager',
  'flexyRideApplications.route': 'Itinéraire',
  'home.fromFallback': 'Origine',
  'home.toFallback': 'Destination',
  'flexyRideApplications.seatsRequested':
    'Places demandées : {{count}}',
  'flexyRideApplications.priceLabel': 'Prix :',
  'flexyRideApplications.priceNA': 'N/D',
  'flexyRideApplications.yourOffer': 'Votre offre',
  'flexyRideApplications.priceLabelInline':
    'Prix : {{price}} {{currency}}',
  'flexyRideApplications.carLabel': 'Voiture : {{brand}}',
  'flexyRideApplications.noteLabel': 'Note : {{note}}',
  'flexyRideApplications.offerSent':
    "Votre offre a été envoyée au propriétaire de l'annonce.",
  'flexyRideApplications.rideInProgress':
    'Trajet en cours. En attente du paiement de {{name}}.',
  'flexyRideApplications.paymentCompleted':
    'Paiement terminé. Nous espérons que votre trajet s’est bien passé !',
  'flexyRideApplications.reviewed': 'Évalué',
  'flexyRideApplications.rate': 'Noter',
  'flexyRideApplications.loginToViewApplications':
    'Veuillez vous connecter pour voir vos candidatures',
  'flexyRideApplications.emptyTitle': 'Aucune candidature pour le moment',
  'flexyRideApplications.emptyDescription':
    "Vous n'avez pas encore postulé à des annonces de trajets passagers",
  'flexyRideApplications.browseRides': 'Voir les trajets',

  // Flexy Ride - My Passenger Listings
  'flexyRideMyPassengerListings.title': 'Mes annonces passager',
  'flexyRideMyPassengerListings.subtitle':
    'Gérez vos annonces de trajets passagers et consultez les demandes reçues',
  'flexyRideMyPassengerListings.deleteConfirm':
    'Êtes-vous sûr de vouloir supprimer cette annonce ? Cette action est irréversible.',
  'flexyRideMyPassengerListings.deleteSuccess':
    'Annonce supprimée avec succès.',
  'flexyRideMyPassengerListings.deleteError':
    "Échec de la suppression de l'annonce. Veuillez réessayer.",
  'flexyRideMyPassengerListings.completedBadge': 'Terminée',
  'flexyRideMyPassengerListings.route': 'Itinéraire',
  'flexyRideMyPassengerListings.seatsRequested':
    '{{count}} places demandées',
  'flexyRideMyPassengerListings.note': 'Note',
  'flexyRideMyPassengerListings.requests': 'Demandes',
  'flexyRideMyPassengerListings.viewRequests':
    'Voir ({{count}})',
  'flexyRideMyPassengerListings.loginToViewListings':
    'Veuillez vous connecter pour voir vos annonces',
  'flexyRideMyPassengerListings.emptyTitle': 'Aucune annonce pour le moment',
  'flexyRideMyPassengerListings.emptyDescription':
    'Créez une nouvelle annonce passager pour commencer à recevoir des demandes de conducteurs',
  'flexyRideMyPassengerListings.createListing': 'Créer une annonce',

  // Flexy Ride - My Seat Requests
  'flexyRideMyRequests.title': 'Mes demandes de siège',
  'flexyRideMyRequests.subtitle':
    'Consultez et gérez vos demandes de siège auprès des conducteurs',
  'flexyRideMyRequests.driverLabel': 'Conducteur',
  'flexyRideMyRequests.route': 'Itinéraire',
  'flexyRideMyRequests.priceSeatsSuffix': '({{count}} sièges)',
  'flexyRideMyRequests.vehicleLabel': 'Véhicule :',
  'flexyRideMyRequests.acceptedMessage':
    'Nous vous souhaitons un agréable voyage. Vous pouvez finaliser votre paiement via le bouton "Confirmer le paiement".',
  'flexyRideMyRequests.completedMessage':
    'Le paiement a été effectué. Nous espérons que votre trajet s’est bien passé. Au plaisir de vous revoir pour vos prochains voyages.',
  'flexyRideMyRequests.confirmPaymentButton': 'Confirmer le paiement',
  'flexyRideMyRequests.loginToViewRequests':
    'Veuillez vous connecter pour voir vos demandes',
  'flexyRideMyRequests.emptyTitle': 'Aucune demande pour le moment',
  'flexyRideMyRequests.emptyDescription':
    "Vous n'avez pas encore envoyé de demandes de siège aux conducteurs",
  'flexyRideMyRequests.browseSeats': 'Voir les sièges',
  'flexyRideMyRequests.paymentConfirmError':
    'Échec de la confirmation du paiement. Veuillez réessayer.',
  'flexyRideMyRequests.modalTitle': 'Confirmer le paiement',
  'flexyRideMyRequests.modalSubtotal': 'Sous-total',
  'flexyRideMyRequests.modalFees': 'Frais (15 %)',
  'flexyRideMyRequests.modalTipLabel': 'Pourboire (facultatif)',
  'flexyRideMyRequests.modalTip': 'Pourboire',
  'flexyRideMyRequests.modalTipPlaceholder': '0,00',
  'flexyRideMyRequests.modalTotal': 'Total',
  'flexyRideMyRequests.modalProcessing': 'Traitement en cours...',

  // Flexy Ride - My Seat Listings
  'flexyRideMySeatListings.title': 'Mes annonces de siège',
  'flexyRideMySeatListings.subtitle':
    'Gérez vos annonces de sièges et consultez les demandes reçues',
  'flexyRideMySeatListings.deleteConfirm':
    'Êtes-vous sûr de vouloir supprimer cette annonce ? Cette action est irréversible.',
  'flexyRideMySeatListings.deleteSuccess': 'Annonce supprimée avec succès.',
  'flexyRideMySeatListings.deleteError':
    "Échec de la suppression de l'annonce. Veuillez réessayer.",
  'flexyRideMySeatListings.completedBadge': 'Terminée',
  'flexyRideMySeatListings.route': 'Itinéraire',
  'flexyRideMySeatListings.pricing': 'Tarification',
  'flexyRideMySeatListings.pricingValue':
    '{{currency}} ${{price}} ({{seats}} sièges)',
  'flexyRideMySeatListings.note': 'Note',
  'flexyRideMySeatListings.requests': 'Demandes',
  'flexyRideMySeatListings.viewRequests': 'Voir ({{count}})',
  'flexyRideMySeatListings.loginToViewListings':
    'Veuillez vous connecter pour voir vos annonces',
  'flexyRideMySeatListings.emptyTitle': 'Aucune annonce pour le moment',
  'flexyRideMySeatListings.emptyDescription':
    'Créez une nouvelle annonce de siège pour commencer à recevoir des demandes de passagers',
  'flexyRideMySeatListings.createListing': 'Créer une annonce',

  // Flexy Ride - Passenger Listing Requests
  'flexyRidePassengerRequests.title': 'Demandes pour mes annonces passager',
  'flexyRidePassengerRequests.subtitle':
    'Gérez les offres des conducteurs pour vos annonces passager.',
  'flexyRidePassengerRequests.paymentPending': 'Paiement en attente',
  'flexyRidePassengerRequests.loginToAccept':
    'Veuillez vous connecter pour accepter des demandes.',
  'flexyRidePassengerRequests.loginToReject':
    'Veuillez vous connecter pour refuser des demandes.',
  'flexyRidePassengerRequests.loginToView':
    'Veuillez vous connecter pour voir les demandes.',
  'flexyRidePassengerRequests.applicationNotFound':
    'Demande introuvable.',
  'flexyRidePassengerRequests.onlyOwnListings':
    'Vous ne pouvez gérer que les demandes concernant vos propres annonces.',
  'flexyRidePassengerRequests.insufficientBalance':
    'Solde insuffisant. Il vous faut {{currency}} {{total}} mais vous avez {{currency}} {{balance}}.',
  'flexyRidePassengerRequests.acceptSuccess':
    'Demande acceptée avec succès !',
  'flexyRidePassengerRequests.acceptError':
    "Échec de l'acceptation de la demande. Veuillez réessayer.",
  'flexyRidePassengerRequests.rejectSuccess': 'Demande refusée.',
  'flexyRidePassengerRequests.rejectError':
    "Échec du refus de la demande. Veuillez réessayer.",
  'flexyRidePassengerRequests.requestNotFound': 'Demande introuvable',
  'flexyRidePassengerRequests.paymentAlreadyConfirmed':
    'Le paiement a déjà été confirmé.',
  'flexyRidePassengerRequests.payerReceiverMissing':
    'Identifiant du payeur ou du bénéficiaire manquant',
  'flexyRidePassengerRequests.rideRequestTitle': 'Demande de trajet',
  'flexyRidePassengerRequests.userNotAuthenticated':
    'Utilisateur non authentifié',
  'flexyRidePassengerRequests.paymentConfirmSuccess':
    'Paiement confirmé. Trajet terminé avec succès !',
  'flexyRidePassengerRequests.paymentConfirmError':
    'Échec de la confirmation du paiement. Veuillez réessayer.',
  'flexyRidePassengerRequests.route': 'Itinéraire',
  'flexyRidePassengerRequests.seatsRequested': 'Places demandées',
  'flexyRidePassengerRequests.empty': 'Aucune demande trouvée.',
  'flexyRidePassengerRequests.requestingDriver': 'Conducteur demandeur',
  'flexyRidePassengerRequests.offer': 'Offre',
  'flexyRidePassengerRequests.offerPriceValue':
    '{{price}} {{currency}}',
  'flexyRidePassengerRequests.offerCarValue': 'Voiture : {{brand}}',
  'flexyRidePassengerRequests.paymentCompleted': 'Paiement terminé',
  'flexyRidePassengerRequests.rideRequestFormatted': 'Trajet : {{from}} → {{to}}',

  // Flexy Ride - Seat Listing Requests
  'flexyRideSeatRequests.title': 'Demandes pour mes annonces de siège',
  'flexyRideSeatRequests.subtitle':
    'Gérez les candidatures des passagers pour vos annonces de siège.',
  'flexyRideSeatRequests.loginToAccept':
    'Veuillez vous connecter pour accepter des demandes.',
  'flexyRideSeatRequests.loginToReject':
    'Veuillez vous connecter pour refuser des demandes.',
  'flexyRideSeatRequests.loginToView':
    'Veuillez vous connecter pour voir les demandes.',
  'flexyRideSeatRequests.applicationNotFound':
    'Demande introuvable.',
  'flexyRideSeatRequests.onlyOwnListings':
    'Vous ne pouvez gérer que les demandes concernant vos propres annonces.',
  'flexyRideSeatRequests.acceptSuccess':
    'Demande acceptée avec succès !',
  'flexyRideSeatRequests.acceptError':
    "Échec de l'acceptation de la demande. Veuillez réessayer.",
  'flexyRideSeatRequests.rejectSuccess': 'Demande refusée.',
  'flexyRideSeatRequests.rejectError':
    "Échec du refus de la demande. Veuillez réessayer.",
  'flexyRideSeatRequests.route': 'Itinéraire',
  'flexyRideSeatRequests.availableSeats': 'Places disponibles',
  'flexyRideSeatRequests.availableSeatsValue': '{{seats}}',
  'flexyRideSeatRequests.availableSeatsWithPrice': '{{seats}} • {{currency}} {{price}}',
  'flexyRideSeatRequests.empty':
    'Aucune demande trouvée pour vos annonces de siège.',
  'flexyRideSeatRequests.requestingPassenger': 'Passager demandeur',
  'flexyRideSeatRequests.price': 'Prix',
  'flexyRideSeatRequests.paymentCompleted': 'Paiement terminé',
  'flexyRideSeatRequests.paymentCompletedMessage':
    'Le paiement a été effectué. Au plaisir de vous revoir pour vos prochains trajets.',
  'flexyRideSeatRequests.rideInProgress':
    'Trajet en cours. En attente du paiement de {{name}}.',

  // Notifications page
  'notifications.title': 'Notifications',
  'notifications.badge': 'Restez informé',
  'notifications.heroDescription':
    'Suivez l’activité de vos trajets, vos demandes, votre portefeuille et les alertes système au même endroit.',
  'notifications.total': '{{count}} au total',
  'notifications.unread': '{{count}} non lues',
  'notifications.sectionTitle': 'Dernières activités',
  'notifications.sectionDescription':
    'Consultez tout ce qui se passe sur vos trajets, demandes et compte.',
  'notifications.markAll': 'Tout marquer comme lu',
  'notifications.emptyTitle': 'Vous êtes à jour !',
  'notifications.emptyDescription':
    'Nous regrouperons vos mises à jour ici. Revenez après une nouvelle activité de trajet ou de demande.',
  'notifications.exploreTrips': 'Explorer les trajets',
  'notifications.defaultTitle': 'Notification',
  'notifications.defaultBody': 'Vous avez une nouvelle mise à jour',
  'notifications.new': 'Nouveau',
  'notifications.asSender': 'En tant qu’expéditeur',
  'notifications.asTraveler': 'En tant que voyageur',
  'notifications.requestId': 'ID de demande :',
  'notifications.loginDescription':
    'Veuillez vous connecter pour voir votre activité, vos mises à jour et vos rappels.',

  // Marketing footer
  'footer.trustedSwaps': 'Échanges de confiance',
  'footer.description':
    'FlexySwap est un réseau logistique pair-à-pair qui aide les voyageurs à monétiser l’espace inutilisé de leurs bagages tandis que les expéditeurs envoient des colis en toute sécurité à travers le monde.',
  'footer.downloadAppsTitle': 'Téléchargez nos applications mobiles',
  'footer.downloadAppsDescription':
    'Gardez chaque échange synchronisé avec des notifications en temps réel et des paiements sécurisés, où que vous soyez.',
  'footer.privacy': 'Politique de confidentialité',
  'footer.terms': "Conditions d'utilisation",
  'footer.copyright':
    '© {{year}} FlexySwap. Tous droits réservés.',

  // Route planner & trips map
  'routePlanner.fromPlaceholder':
    'Aéroport, gare routière, hôtel...',
  'routePlanner.toPlaceholder': 'Point de dépose',
  'routePlanner.loadingMaps': 'Chargement de Google Maps...',

  'tripsMap.mapPreview': 'Aperçu de la carte',
  'tripsMap.defaultTitle': 'Trajets disponibles sur la carte',
  'tripsMap.showingLocations': '{{count}} emplacements affichés',
  'tripsMap.selectedTrip': 'Trajet sélectionné',
  'tripsMap.viewDetails': 'Voir les détails',
  'tripsMap.route': 'Itinéraire',
  'tripsMap.capacity': 'Capacité',

  // Request Modal
  'requestModal.title': 'Demander une livraison',
  'requestModal.travelerFallback': 'Voyageur',
  'requestModal.itemDetails': 'Détails de l\'article',
  'requestModal.itemName': 'Nom de l\'article',
  'requestModal.itemNamePlaceholder': 'ex. : Documents, Électronique, Vêtements',
  'requestModal.notesLabel': 'Notes (optionnel)',
  'requestModal.notesPlaceholder': 'Toute instruction ou détail spécial',
  'requestModal.pricing': 'Tarification',
  'requestModal.subtotal': 'Sous-total :',
  'requestModal.serviceFee': 'Frais de service (15 %) :',
  'requestModal.total': 'Total :',
  'requestModal.loadingBalance': 'Chargement du solde...',
  'requestModal.balance': 'Votre solde : {{currency}} {{amount}}',
  'requestModal.sending': 'Envoi...',
  'requestModal.sendRequest': 'Envoyer la demande',
  'requestModal.validation.itemNameRequired': 'Veuillez saisir le nom de l\'article',
  'requestModal.validation.loginRequired': 'Veuillez vous connecter pour envoyer une demande',
  'requestModal.validation.insufficientBalance': 'Vous avez {{currency}} {{current}} mais il vous faut {{currency}} {{total}}.\nVeuillez ajouter {{currency}} {{shortfall}} à votre portefeuille.',
  'requestModal.error.tripIdMissing': 'L\'ID du voyage est manquant',
  'requestModal.error.tripOwnerMissing': 'L\'ID du propriétaire du voyage est manquant',
  'requestModal.error.generic': 'Échec de l\'envoi de la demande. Veuillez réessayer.',
  'requestModal.success': 'Demande envoyée avec succès !',

  // Send Offer Modal
  'sendOfferModal.title': 'Proposer de transporter',
  'sendOfferModal.senderFallback': 'Expéditeur',
  'sendOfferModal.deliveryMethodLabel': 'Méthode de livraison',
  'sendOfferModal.selectDeliveryMethodPlaceholder': 'Sélectionnez une méthode de livraison',
  'sendOfferModal.askingPrice': 'Prix demandé',
  'sendOfferModal.pricePlaceholder': 'Entrer le montant',
  'sendOfferModal.notesLabel': 'Notes (optionnel)',
  'sendOfferModal.notesPlaceholder': 'Toute instruction spéciale pour le transport de vos articles',
  'sendOfferModal.itemFallback': 'Article',
  'sendOfferModal.selectDeliveryMethodTitle': 'Sélectionner la méthode de livraison',
  'sendOfferModal.send': 'Envoyer',
  'sendOfferModal.sending': 'Envoi...',
  'sendOfferModal.validation.deliveryMethodRequired': 'Veuillez sélectionner une méthode de livraison',
  'sendOfferModal.validation.priceRequired': 'Veuillez saisir un prix valide',
  'sendOfferModal.validation.currencyRequired': 'Veuillez sélectionner une devise',
  'sendOfferModal.validation.loginRequired': 'Veuillez vous connecter pour envoyer une offre',
  'sendOfferModal.error.tripIdMissing': 'L\'ID du voyage est manquant',
  'sendOfferModal.error.tripOwnerMissing': 'L\'ID du propriétaire du voyage est manquant',
  'sendOfferModal.error.generic': 'Échec de l\'envoi de l\'offre. Veuillez réessayer.',
  'sendOfferModal.success': 'Offre envoyée avec succès !',

  // Review Modal
  'reviewModal.title': 'Évaluez votre expérience',
  'reviewModal.description': 'Comment était votre expérience avec {{name}} ?',
  'reviewModal.descriptionFallback': 'Partagez vos commentaires avec cet utilisateur.',
  'reviewModal.placeholder': 'Rédiger un avis (optionnel)...',
  'reviewModal.selectRatingError': 'Veuillez sélectionner une note avant de soumettre.',
  'reviewModal.submitError': 'Échec de la soumission de l\'avis. Veuillez réessayer.',
  'reviewModal.submitting': 'Envoi...',
  'reviewModal.submit': 'Soumettre',

  // Wallet
  'wallet.title': 'Portefeuille',
  'wallet.badge': 'Portefeuille et solde',
  'wallet.heroTitle': 'Votre portefeuille FlexySwap',
  'wallet.heroDescription':
    'Gardez un œil sur les dépôts, les retraits et les gains de voyage depuis un seul endroit. Gérez les comptes de paiement et examinez chaque transaction en toute confiance.',
  'wallet.loginDescription':
    'Veuillez vous connecter pour voir le solde et les transactions de votre portefeuille.',
  'wallet.loading': 'Chargement des données du portefeuille...',
  'wallet.availableBalance': 'Solde disponible',
  'wallet.availableBalanceLabel': 'Solde disponible · {{amount}}',
  'wallet.totalTransactions': '{{count}} transactions au total',
  'wallet.balanceDescription':
    'Mis à jour automatiquement à partir de vos gains de voyage, dépôts et retraits.',
  'wallet.addMoney': 'Ajouter de l\'argent',
  'wallet.accountStatus': 'Statut du compte',
  'wallet.depositAccount': 'Compte de dépôt',
  'wallet.depositAccountStatus': 'Paiements Stripe · Prêt',
  'wallet.withdrawalAccount': 'Compte de retrait',
  'wallet.withdrawalAccountConnected': 'Connecté · …{{accountId}}',
  'wallet.withdrawalAccountNotConnected': 'Non connecté',
  'wallet.manage': 'Gérer',
  'wallet.configure': 'Configurer',
  'wallet.totalDeposits': 'Total des dépôts',
  'wallet.depositsCount_one': '{{count}} dépôt',
  'wallet.depositsCount_other': '{{count}} dépôts',
  'wallet.totalWithdrawals': 'Total des retraits',
  'wallet.withdrawalsCount_one': '{{count}} retrait',
  'wallet.withdrawalsCount_other': '{{count}} retraits',
  'wallet.transactions': 'Transactions',
  'wallet.lifetimeActivity': 'Activité à vie',
  'wallet.recentTransactions': 'Transactions récentes',
  'wallet.activity': 'Activité',
  'wallet.viewAll': 'Voir tout',
  'wallet.noTransactions':
    'Aucune transaction pour le moment. Une fois que vous commencerez à envoyer ou à livrer des colis, vos gains et paiements apparaîtront ici.',
  'wallet.walletActivity': 'Activité du portefeuille',
  'wallet.statusCompleted': 'terminé',

  // All Transactions
  'wallet.allTransactions.backToWallet': 'Retour au portefeuille',
  'wallet.allTransactions.title': 'Toutes les transactions',
  'wallet.allTransactions.subtitle':
    'Vue détaillée des dépôts, retraits et paiements de voyage.',
  'wallet.allTransactions.filter.all': 'Tout',
  'wallet.allTransactions.filter.deposit': 'Dépôt',
  'wallet.allTransactions.filter.withdrawal': 'Retrait',
  'wallet.allTransactions.filter.earning': 'Gain',
  'wallet.allTransactions.filter.payment': 'Paiement',
  'wallet.allTransactions.noTransactions':
    'Aucune transaction trouvée pour ce filtre.',
  'wallet.allTransactions.table.description': 'Description',
  'wallet.allTransactions.table.type': 'Type',
  'wallet.allTransactions.table.amount': 'Montant',
  'wallet.allTransactions.table.status': 'Statut',
  'wallet.allTransactions.table.date': 'Date',
  'wallet.allTransactions.transactionType.deposit': 'Dépôt',
  'wallet.allTransactions.transactionType.withdrawal': 'Retrait',
  'wallet.allTransactions.transactionType.earning': 'Gain',
  'wallet.allTransactions.transactionType.payment': 'Paiement',
  'wallet.allTransactions.details': 'Détails',

  // Transaction Detail
  'wallet.transactionDetail.backToTransactions': 'Retour aux transactions',
  'wallet.transactionDetail.loading': 'Chargement des détails de la transaction...',
  'wallet.transactionDetail.notFound': 'Transaction introuvable.',
  'wallet.transactionDetail.title': 'Détails de la transaction',
  'wallet.transactionDetail.type.deposit': 'Dépôt',
  'wallet.transactionDetail.type.withdrawal': 'Retrait',
  'wallet.transactionDetail.type.earning': 'Gain de voyage',
  'wallet.transactionDetail.type.walletActivity': 'Activité du portefeuille',
  'wallet.transactionDetail.detail.description': 'Description',
  'wallet.transactionDetail.detail.walletActivity': 'Activité du portefeuille',
  'wallet.transactionDetail.detail.status': 'Statut',
  'wallet.transactionDetail.detail.date': 'Date',
  'wallet.transactionDetail.detail.from': 'De',
  'wallet.transactionDetail.detail.to': 'À',
  'wallet.transactionDetail.detail.requestId': 'ID de la demande',
  'wallet.transactionDetail.detail.paymentMethod': 'Méthode de paiement',
  'wallet.transactionDetail.detail.withdrawalMethod': 'Méthode de retrait',
  'wallet.transactionDetail.detail.tip': 'Pourboire',

  // Withdrawal Account
  'wallet.withdrawalAccount.withdrawalMethod': 'Méthode de retrait',
  'wallet.withdrawalAccount.title': 'Paiements Stripe Connect',
  'wallet.withdrawalAccount.description':
    'Connectez votre compte Stripe Express pour recevoir des paiements. Une fois votre compte vérifié, les retraits du portefeuille FlexySwap peuvent être envoyés directement à votre banque. Le processus d\'intégration vous demandera votre nom légal, votre compte bancaire et vos documents de vérification comme requis par Stripe.',
  'wallet.withdrawalAccount.currentStatus': 'Statut actuel',
  'wallet.withdrawalAccount.onboardingOpened':
    'L\'intégration Stripe Connect a été ouverte dans un nouvel onglet.',
  'wallet.withdrawalAccount.unableToStartOnboarding':
    'Impossible de démarrer l\'intégration Stripe.',
  'wallet.withdrawalAccount.accountNotFound':
    'Compte Stripe Connect introuvable. Veuillez d\'abord compléter l\'intégration.',
  'wallet.withdrawalAccount.unableToCheckStatus':
    'Impossible de vérifier le statut du compte.',
  'wallet.withdrawalAccount.startOnboarding': 'Démarrer l\'intégration',
  'wallet.withdrawalAccount.securityNote':
    'Stripe stocke vos informations bancaires en toute sécurité. FlexySwap ne suit que l\'état de la connexion et ne voit jamais vos numéros de compte.',

  // Deposit Account
  'wallet.depositAccount.depositMethod': 'Méthode de dépôt',
  'wallet.depositAccount.title': 'Paiements par carte via Stripe',
  'wallet.depositAccount.description':
    'FlexySwap utilise Stripe pour les paiements par carte sécurisés. Votre compte de dépôt est automatiquement préparé lorsque vous vérifiez votre profil. Aucune configuration manuelle n\'est requise—il suffit de sélectionner un montant pour ajouter des fonds sur la page Ajouter de l\'argent.',
  'wallet.depositAccount.cardsSupported': 'Cartes prises en charge',
  'wallet.depositAccount.cardsList': 'Visa, Mastercard, Amex, Maestro',
  'wallet.depositAccount.securityNote':
    'Les détails de la carte sont tokenisés par Stripe. FlexySwap ne stocke jamais vos informations de paiement. Chaque transaction est protégée par Stripe Radar pour la prévention de la fraude.',
  'wallet.depositAccount.infoNote':
    'Besoin de mettre à jour votre carte ? Commencez un nouveau dépôt depuis la page Ajouter de l\'argent pour ajouter une autre carte. Les reçus sont envoyés automatiquement par e-mail par Stripe.',
  'wallet.depositAccount.makeDeposit': 'Effectuer un dépôt',

  // Withdraw Money
  'wallet.withdrawMoney.title': 'Retirer de l\'argent',
  'wallet.withdrawMoney.signInToAccess':
    'Veuillez vous connecter pour accéder à votre portefeuille.',
  'wallet.withdrawMoney.insufficientBalance':
    'Solde insuffisant. Disponible : {{available}}',
  'wallet.withdrawMoney.accountReady':
    'Votre compte est prêt pour les retraits !',
  'wallet.withdrawMoney.noAccountFound':
    'Aucun compte Stripe Connect trouvé. Veuillez d\'abord configurer votre compte.',
  'wallet.withdrawMoney.failedToCheckStatus':
    'Échec de la vérification du statut du compte : {{error}}',
  'wallet.withdrawMoney.payoutsNotAvailable':
    'Les paiements Stripe Connect ne sont pas disponibles dans {{country}}. Veuillez mettre à jour votre profil avec un pays pris en charge.',
  'wallet.withdrawMoney.unableToGetOnboardingLink':
    'Impossible d\'obtenir le lien d\'intégration Stripe.',
  'wallet.withdrawMoney.failedToSetupAccount':
    'Échec de la configuration du compte : {{error}}',
  'wallet.withdrawMoney.enterValidAmount':
    'Veuillez entrer un montant valide.',
  'wallet.withdrawMoney.connectAccountFirst':
    'Connectez un compte de paiement avant de retirer.',
  'wallet.withdrawMoney.withdrawalsNotAvailable':
    'Les retraits ne sont pas disponibles dans {{country}}. Veuillez mettre à jour votre profil avec un pays pris en charge.',
  'wallet.withdrawMoney.accountNeedsSetup':
    'Votre compte Stripe Connect doit être configuré ou complété. Veuillez d\'abord compléter la configuration du compte.',
  'wallet.withdrawMoney.accountSetupInProgress':
    'La configuration du compte est toujours en cours. Veuillez attendre un moment et réessayer.',
  'wallet.withdrawMoney.withdrawalQueued':
    'Retrait de {{amount}} en file d\'attente. Les paiements arrivent généralement dans 2-3 jours ouvrables.',
  'wallet.withdrawMoney.failedToSubmit': 'Échec de la soumission du retrait.',
  'wallet.withdrawMoney.connectPayoutAccount': 'Connecter le compte de paiement',
  'wallet.withdrawMoney.generatingOnboardingLink':
    'Génération du lien d\'intégration Stripe...',
  'wallet.withdrawMoney.onboardingOpened':
    'L\'intégration Stripe a été ouverte dans un nouvel onglet. Si elle a été bloquée ou si vous l\'avez fermée, utilisez le bouton ci-dessous pour la rouvrir.',
  'wallet.withdrawMoney.openOnboarding': 'Ouvrir l\'intégration Stripe',
  'wallet.withdrawMoney.clickToLaunch':
    'Cliquez sur "Connecter / mettre à jour" pour lancer l\'intégration Stripe.',

  // Auth / Login
  'auth.loginSuccess': 'Bon retour ! Redirection…',
  'auth.signupSuccess': 'Compte créé ! Vous êtes maintenant connecté.',
  'auth.usernameRequired': "Le nom d'utilisateur est requis.",
  'auth.resetEnterEmail': 'Saisissez votre e-mail pour réinitialiser le mot de passe.',
  'auth.resetEmailSent': 'E-mail de réinitialisation du mot de passe envoyé.',

  'auth.badgeSignin': 'Connexion',
  'auth.badgeSignup': 'Créer un compte',
  'auth.heroSigninTitle': 'Conduisez quand vous voulez, gagnez ce dont vous avez besoin.',
  'auth.heroSignupTitle': 'Rejoignez FlexySwap et commencez à gagner dès aujourd’hui.',
  'auth.heroSigninSubtitle':
    'Reprenez exactement là où vous vous êtes arrêté, côté expéditeur ou voyageur.',
  'auth.heroSignupSubtitle':
    'Publiez des trajets, gérez les demandes et synchronisez chaque remise en main propre instantanément.',

  'auth.identifierLabel': 'E-mail ou nom d’utilisateur',
  'auth.identifierPlaceholder': 'email@exemple.com ou nom d’utilisateur',
  'auth.emailLabel': 'E-mail',
  'auth.usernameLabel': "Nom d'utilisateur",
  'auth.passwordLabel': 'Mot de passe',

  'auth.forgotPassword': 'Mot de passe oublié ?',
  'auth.signingIn': 'Connexion en cours...',
  'auth.creatingAccount': 'Création du compte...',
  'auth.signinCta': 'Se connecter',
  'auth.signupCta': "S'inscrire",

  'auth.noAccount': "Vous n'avez pas de compte ?",
  'auth.haveAccount': 'Vous avez déjà un compte ?',
  'auth.createOne': 'Créer un compte',
  'auth.signinLink': 'Se connecter',

  'auth.downloadApp': "Télécharger l'application mobile",
  'auth.sideHeroTitle': 'Retrouvez-vous à la porte, échangez en quelques secondes.',
  'auth.sideHeroDescription':
    'Des voyageurs vérifiés récupèrent votre colis, confirment les identités et synchronisent instantanément le statut avec votre tableau de bord FlexySwap.',
  'auth.sideHeroPillTracking': 'Suivi en temps réel',
  'auth.sideHeroPillPayouts': 'Paiements sécurisés',
  'auth.sideHeroPillIds': 'Identités vérifiées',

  // Login terms and privacy
  'login.acceptTerms': 'J\'accepte les',
  'login.termsOfService': 'Conditions d\'utilisation',
  'login.and': 'et',
  'login.privacyPolicy': 'Politique de confidentialité',
  'login.mustAcceptTerms': 'Vous devez accepter les Conditions d\'utilisation et la Politique de confidentialité pour créer un compte',
};

